{
  "LogbookApp_version_major": "1.1",

  "RecordingClockWarning_title": "Avertissement sur l’heure d’enregistrement",
  "RecordingClockWarning_acknowledge": "Compris",
  "RecordingClockWarning_system": "L’horloge de l’ordinateur n’est pas fiable. L’enregistrement continue avec l’heure GPS.",
  "RecordingClockWarning_gps": "L’horloge GPS n’est pas fiable. L’enregistrement continue avec l’heure de l’ordinateur.",
  "RecordingClockWarning_paused": "Aucune source horaire fiable n’est disponible. L’enregistrement automatique et les nouvelles entrées à l’heure actuelle sont suspendus jusqu’au rétablissement du GPS ou de l’horloge de l’ordinateur. Les anciennes entrées restent modifiables.",

  "Layout": "",
  "Layout_documentation": "DOCUMENTATION",
  "Layout_support": "Assistance",

  "OpenServerDialog_title": "Ouvrir LOGBOOK Cloud",
  "OpenServerDialog_opening": "Ouverture de LOGBOOK Cloud...",
  "OpenServerDialog_failed": "Impossible d'ouvrir LOGBOOK Cloud. Vérifiez votre connexion et autorisez les fenêtres contextuelles, puis réessayez.",
  "OpenServerDialog_close": "Fermer",
  "OpenServerDialog_retry": "Réessayer",

  "AboutView": "",
  "AboutView_title": "À propos de LOGBOOK",
  "AboutView_version": "Version",
  "AboutView_website": "Site Web",
  "AboutView_support": "Assistance",
  "AboutView_copyright": "Copyright © 2026 par Trimutic UG",
  "AboutView_uploadAppData": "Téléverser les données de l'application au support",
  "AboutView_uploadAppDataUploading": "Téléversement en cours…",
  "AboutView_uploadAppDataSuccess": "Données de l'application téléversées",
  "AboutView_uploadAppDataError": "Échec du téléversement des données de l'application",

  "AccountView": "",
  "AccountView_cancel": "Annuler",
  "AccountView_cancel_plan": "Annuler l'abonnement",
  "AccountView_currency": "Devise",
  "AccountView_currency_EUR": "Euro (€)",
  "AccountView_currency_USD": "Dollar US ($)",
  "AccountView_duration": "Durée",
  "AccountView_duration_5": "5 jours",
  "AccountView_duration_30": "facturation\u00A0mensuelle, résiliable\u00A0mensuellement",
  "AccountView_duration_120": "4 mois",
  "AccountView_duration_365": "facturation\u00A0annuelle, résiliable\u00A0annuellement",
  "AccountView_duration_30_iap": "facturation\u00A0mensuelle, renouvellement automatique sauf\u00A0annulation",
  "AccountView_feature_active_ships": "Navires actifs : {amount}",
  "AccountView_feature_active_users": "Utilisateurs actifs : {amount}",
  "AccountView_feature_active_tenders": "Annexes actives : {amount}",
  "AccountView_feature_support_1": "Assistance Standard",
  "AccountView_feature_support_10": "Assistance Pro",
  "AccountView_feature_support_100": "Assistance Master",
  "AccountView_feature_unlimited": "Illimité",
  "AccountView_pay": "Confirmer le paiement récurrent de {price}",
  "AccountView_pay_cancel": "Annuler",
  "AccountView_pay_processing": "Traitement du paiement…",
  "AccountView_payment_information": "Informations de paiement",
  "AccountView_payment_title": "Abonnement {plan} pour {price}",
  "AccountView_plans": "Nos abonnements",
  "AccountView_plans_iPad": "Votre abonnement LOGBOOK",
  "AccountView_plan_captain": "LOGBOOK Captain",
  "AccountView_plan_master_captain": "LOGBOOK Master Captain",
  "AccountView_plan_skipper": "LOGBOOK Skipper",
  "AccountView_plan_trial": "LOGBOOK Trial",
  "AccountView_price_duration_5": "5 jours",
  "AccountView_price_duration_30": "mois",
  "AccountView_price_duration_365": "année",
  "AccountView_price_free": "Gratuit",
  "AccountView_price_EUR": "{price} € par {duration}",
  "AccountView_price_USD": "{price} $ par {duration}",
  "AccountView_price_native": "{price} par {duration}",
  "AccountView_price_or_monthly": " ou ",
  "AccountView_select_plan": "Sélectionner un forfait",
  "AccountView_subscribe": "S'abonner",
  "AccountView_subscribe_api": "S'abonner",
  "AccountView_time_left": "{days} jours restants",
  "AccountView_renews_in": "Renouvellement dans {days} jours",
  "AccountView_cancelled_ends": "Annulé — accès jusqu'à la fin dans {days} jours",
  "AccountView_apple_cancel_info_title": "Gérer votre abonnement",
  "AccountView_apple_cancel_info_message": "Cet abonnement a été souscrit via l'App Store et doit donc y être géré. Sur votre iPhone ou iPad, ouvrez Réglages, touchez votre nom, puis Abonnements, sélectionnez LOGBOOK et annulez-le à cet endroit. Votre accès reste actif jusqu'à la fin de la période de facturation en cours.",
  "AccountView_taxes": "Taxes incluses",
  "AccountView_terms_of_use": "Conditions d'utilisation",
  "AccountView_privacy_policy": "Politique de confidentialité",
  "AccountView_restore_purchases": "Restaurer les achats",
  "AccountView_restore_purchases_running": "Restauration…",
  "AccountView_restore_nothing_title": "Aucun achat trouvé",
  "AccountView_restore_nothing_message": "Aucun abonnement actif à restaurer sur cet identifiant Apple.",
  "AccountView_restore_claim_title": "Déplacer l'abonnement",
  "AccountView_restore_claim_message": "L'abonnement de cet identifiant Apple est actuellement lié à « {account} ». Le déplacer vers « {current} » ? « {account} » perdra l'accès.",
  "AccountView_restore_claim_confirm": "Déplacer ici",
  "AccountView_restore_claim_cancel": "Le laisser là",
  "AccountView_linked_to_other_account": "L'abonnement de cet identifiant Apple est lié au compte LOGBOOK « {account} ».",
  "AccountView_linked_to_other_account_hint": "Utilisez « Restaurer les achats » pour le déplacer vers ce compte, ou payez par carte sur le web.",
  "AccountView_title": "Paramètres du compte",
  "AccountView_total": "Total dû",

  "AccountSettingsView_alert_no_internet_title": "Aucune connexion Internet disponible",
  "AccountSettingsView_alert_no_internet_text": "Une connexion Internet est requise pour modifier les paramètres du compte.",

  "AccountSettingsView_error_passwordInvalid": "Le mot de passe saisi ne correspond pas au mot de passe actuel.",
  "AccountSettingsView_error_passwordConfirmationMismatch": "La confirmation du mot de passe ne correspond pas au mot de passe.",
  "AccountSettingsView_error_Not Found": "Non trouvé",
  "AccountSettingsView_error_accountUserSelfAction": "Vous ne pouvez pas modifier, désactiver ou supprimer votre propre accès.",
  "AccountSettingsView_error_accountUserLastAdmin": "Le compte doit conserver au moins un administrateur actif.",
  "AccountSettingsView_error_account_user_action_failed": "Une erreur s'est produite. Veuillez réessayer.",
  "AccountSettingsView_error_account_update_failed": "Une erreur s'est produite. Veuillez réessayer.",
  "AccountSettingsView_change_password": "Modifier le mot de passe",
  "AccountSettingsView_confirm_new_password": "Confirmation du nouveau mot de passe",
  "AccountSettingsView_current_password": "Mot de passe actuel",
  "AccountSettingsView_new_password": "Nouveau mot de passe",

  "AccountSettingsView_import_ship": "Importer depuis LogbookSuite",
  "AccountSettingsView_import_trips": "Importer les trajets pour \"{name}\" depuis LogbookSuite",
  "AccountSettingsView_new_ship": "Commencer avec un nouveau navire",
  "AccountSettingsView_select_ship": "Sélectionner parmi vos navires",
  "AccountSettingsView_select_shared_ship": "Sélectionner parmi les navires partagés",
  "AccountSettingsView_deselect_ship": "Fermer le navire",
  "AccountSettingsView_add_new_ship": "Ajouter un nouveau navire",
  "AccountSettingsView_users_list": "Liste de tous les utilisateurs de votre compte",

  "AccountSettingsView_tab_ships": "Vos navires",
  "AccountSettingsView_tab_subscription": "Votre abonnement",
  "AccountSettingsView_tab_users": "Vos utilisateurs",

  "AccountSettingsView_ship_open_here_notice": "Fermez le LOGBOOK déjà ouvert sur cet appareil pour sélectionner un autre navire.",
  "AccountSettingsView_companion_reconnect_notice": "La connexion au LOGBOOK Primary a été perdue — son adresse sur ce réseau a peut-être changé. Reconnectez-vous pour continuer.",
  "AccountSettingsView_ship_close_companion": "Déconnecter LOGBOOK Companion",
  "AccountSettingsView_ship_close_confirm": "Fermer LOGBOOK",
  "AccountSettingsView_ship_logbook": "Afficher le LOGBOOK pour \"{name}\"",

  "AccountSettingsView_account_data": "Données de votre compte",
  "AccountSettingsView_account_edit_cancel": "Annuler",
  "AccountSettingsView_account_edit_save": "Enregistrer",
  "AccountSettingsView_account_login": "Identifiant (e-mail)",
  "AccountSettingsView_account_name": "Nom du compte",
  "AccountSettingsView_account_settings": "Paramètres du compte",
  "AccountSettingsView_account_user_level": "Autorisations",
  "AccountSettingsView_account_user_level_admin": "Admin",
  "AccountSettingsView_account_user_level_user": "Utilisateur",
  "AccountSettingsView_account_user_level_disabled": "Désactivé",
  "AccountSettingsView_deactivate_user": "Désactiver",
  "AccountSettingsView_reactivate_user": "Réactiver",
  "AccountSettingsView_remove_user": "Supprimer",
  "AccountSettingsView_user_deactivate_confirm_title": "Désactiver l'utilisateur",
  "AccountSettingsView_user_deactivate_confirm_message": "Cet utilisateur a encore accès à un navire de ce compte. Voulez-vous vraiment désactiver son compte ?",
  "AccountSettingsView_user_deactivate_confirm_accept": "Désactiver",
  "AccountSettingsView_user_deactivate_confirm_cancel": "Annuler",
  "AccountSettingsView_user_remove_confirm_title": "Supprimer l'utilisateur",
  "AccountSettingsView_user_remove_confirm_message": "Cet utilisateur a encore accès à un navire de ce compte. Voulez-vous vraiment le supprimer du compte ? Cette action est irréversible.",
  "AccountSettingsView_user_remove_confirm_accept": "Supprimer",
  "AccountSettingsView_user_remove_confirm_cancel": "Annuler",
  "AccountSettingsView_change_plan": "Modifier votre forfait",
  "AccountSettingsView_customer_name": "Nom",
  "AccountSettingsView_edit_account": "Modifier le compte",
  "AccountSettingsView_remove_account": "Supprimer le compte",
  "AccountSettingsView_plan": "Votre forfait actuel",
  "AccountSettingsView_plans": "Forfaits LOGBOOK",
  "AccountSettingsView_subscription": "Votre abonnement",
  "AccountSettingsView_user_account": "Compte",
  "AccountSettingsView_user_name": "Nom",
  "AccountSettingsView_user_email": "E-mail",
  "AccountSettingsView_user_shortname": "Nom court",
  "AccountSettingsView_user_status": "Statut",
  "AccountSettingsView_user_status_active": "Actif",
  "AccountSettingsView_user_status_invited": "Invité",
  "AccountSettingsView_user_permissions": "Autorisations",
  "AccountSettingsView_current_ship": "Votre navire actuel est {name}",
  "AccountSettingsView_no_current_ship": "Aucun navire sélectionné",
  "AccountSettingsView_valid_until": "Valide jusqu'au",
  "AccountSettingsView_trial_days_remaining": "Jours d'essai restants",
  "AccountSettingsView_trial_days_value": "{days} jours",

  "AccountSettingsView_user_crew_role": "Rôle d'équipage",
  "AccountSettingsView_ship_user_crew_role_crew": "Équipage",
  "AccountSettingsView_ship_user_crew_role_none": "Aucun",
  "AccountSettingsView_ship_user_crew_role_owner": "Titulaire du compte",
  "AccountSettingsView_ship_user_crew_role_skipper": "Capitaine",

  "AccountSettingsView_ship_user_level": "Autorisations",
  "AccountSettingsView_ship_user_level_primary": "Primary",
  "AccountSettingsView_ship_user_level_editAll": "Voir et modifier tout",
  "AccountSettingsView_ship_user_level_editCurrent": "Voir et modifier le voyage actuel",
  "AccountSettingsView_ship_user_level_viewAll": "Voir tout",
  "AccountSettingsView_ship_user_level_viewCurrent": "Voir le voyage actuel",
  "AccountSettingsView_ship_user_level_none": "Aucun",

  "AppDisconnectedView": "",
  "AppDisconnectedView_connection_overlay_reload": "Recharger",
  "AppDisconnectedView_connection_overlay_reloading": "Rechargement …",
  "AppDisconnectedView_connection_overlay_title": "Connexion interrompue",
  "AppDisconnectedView_disconnect_companion": "Déconnecter LOGBOOK Companion",

  "AppHeaderView": "",

  "AppOverlayContentView": "",
  "AppOverlayContentView_cancel": "Annuler",
  "AppOverlayContentView_connect_logbook": "Connecter avec le LOGBOOK Primary",
  "AppOverlayContentView_connect_logbook_title": "Connecter avec le LOGBOOK Primary pour \"{name}\"",
  "AppOverlayContentView_connect_logbook_failed": "Échec de la connexion avec le LOGBOOK Primary",
  "AppOverlayContentView_connect_logbook_connecting": "Connexion au LOGBOOK Primary de \"{name}\"…",
  "AppOverlayContentView_connect_logbook_connecting_short": "Connexion…",
  "AppOverlayContentView_connect_logbook_timeout": "Impossible de joindre \"{name}\" automatiquement — saisissez son adresse",
  "AppOverlayContentView_connect_logbook_not_discovered": "« {name} » n’est pas visible sur ce réseau. Vérifiez que les deux appareils utilisent le même Wi-Fi, ou saisissez son adresse ci-dessous.",
  "AppOverlayContentView_connect_logbook_ambiguous": "Plusieurs appareils proposent « {name} ». Saisissez l’adresse de celui auquel vous souhaitez vous connecter.",
  "AppOverlayContentView_connect_logbook_unresolved": "« {name} » a été trouvé, mais son adresse n’a pas pu être déterminée. Saisissez-la ci-dessous.",
  "AppOverlayContentView_connect_logbook_unreachable": "Aucune réponse de « {name} » à l’adresse {address}. Vérifiez l’adresse et que les deux appareils sont sur le même réseau.",
  "AppOverlayContentView_connect_logbook_refused": "« {name} » a refusé la connexion. Assurez-vous que l’utilisateur de cet appareil a accès à ce journal de bord.",
  "AppOverlayContentView_connect_logbook_not_claimed": "« {name} » n’est pas ouvert sur le LOGBOOK Primary actuellement. Ouvrez-le là-bas, puis réessayez.",
  "AppOverlayContentView_connect_logbook_not_accessible": "Vous n’avez pas accès à « {name} ».",
  "AppOverlayContentView_connect_logbook_address_invalid": "Saisissez l’adresse sous la forme hôte:port, par exemple 192.168.1.20:18092.",
  "AppOverlayContentView_connect_logbook_own_device": "« {name} » est le journal de bord de cet appareil — ouvrez-le au lieu de vous y connecter.",
  "AppOverlayContentView_connect_logbook_outdated_title": "Cette application n'est pas à jour",
  "AppOverlayContentView_connect_logbook_outdated": "Le LOGBOOK Primary de \"{name}\" utilise une version plus récente que cet appareil. Mettez LOGBOOK à jour ici pour vous connecter.",
  "AppOverlayContentView_connect_logbook_outdated_version": "Cet appareil utilise la version {version}.",
  "AppOverlayContentView_connect_logbook_outdated_appstore": "Veuillez mettre LOGBOOK à jour dans l'App Store.",
  "AppOverlayContentView_connect_logbook_outdated_playstore": "Veuillez mettre LOGBOOK à jour dans le Play Store.",
  "AppOverlayContentView_connect_logbook_outdated_download": "Télécharger la dernière version",
  "AppOverlayContentView_connection": "Entrez l'IP et le port du LOGBOOK Primary pour établir une connexion. Utilisez le format \"IP:Port\", par ex. \"192.168.0.100:8000\".",
  "AppOverlayContentView_connection_host": "Hôte",
  "AppOverlayContentView_connection_port": "Port",
  "AppOverlayContentView_disconnect_logbook": "Déconnecter le LOGBOOK Primary",
  "AppOverlayContentView_disconnect_ship": "Déconnecter le navire",
  "AppOverlayContentView_disconnect_ship_title": "Déconnecter le navire du LOGBOOK Cloud",
  "AppOverlayContentView_import_reset": "Réinitialiser toutes les données importées",
  "AppOverlayContentView_import_reset_confirm_title": "Réinitialiser toutes les données importées ?",
  "AppOverlayContentView_import_reset_confirm_text": "Cela supprimera définitivement tous les trajets importés. Cette action ne peut pas être annulée.",
  "AppOverlayContentView_import_reset_confirm_no": "Annuler",
  "AppOverlayContentView_import_reset_confirm_yes": "Oui, réinitialiser",
  "AppOverlayContentView_import_resetting": "Réinitialisation…",
  "AppOverlayContentView_import_ship_cancel": "Annuler",
  "AppOverlayContentView_import_ship_choose": "Choisir un fichier",
  "AppOverlayContentView_import_ship_title": "Importer depuis Logbook Suite",
  "AppOverlayContentView_import_trips": "Importer depuis Logbook Suite",
  "AppOverlayContentView_import_status_in_progress": "Importation en cours depuis {time}",
  "AppOverlayContentView_import_status_complete": "Importation terminée le {date}",
  "AppOverlayContentView_import_status_failed": "La tentative d'importation précédente a échoué. Veuillez réessayer ou contacter l'assistance pour obtenir de l'aide.",
  "AppOverlayContentView_options_cruises": "Total des voyages dans LOGBOOK :",
  "AppOverlayContentView_options_days": "Total des jours dans le LOGBOOK :",
  "AppOverlayContentView_options_first_day": "Premier jour dans le LOGBOOK :",
  "AppOverlayContentView_options_last_day": "Dernier jour dans le LOGBOOK :",
  "AppOverlayContentView_options_trips": "Total des trajets dans le LOGBOOK :",
  "AppOverlayContentView_options_ship": "Options pour \"{name}\"",
  "AppOverlayContentView_options_ship_title": "Informations sur le navire",
  "AppOverlayContentView_options_update": "Dernière synchronisation :",
  "AppOverlayContentView_logout_confirm": "Déconnexion",
  "AppOverlayContentView_logout_confirm_cancel": "Annuler",
  "AppOverlayContentView_logout_confirm_title": "Confirmer la déconnexion",
  "AppOverlayContentView_remove_account_cancel": "Annuler",
  "AppOverlayContentView_remove_account_confirm": "Confirmer",
  "AppOverlayContentView_remove_account_confirm_title": "Suppression du compte",
  "AppOverlayContentView_session_expired_dismiss": "Continuer sans synchronisation",
  "AppOverlayContentView_session_expired_email": "E-mail",
  "AppOverlayContentView_session_expired_failed": "Échec de la connexion. Vérifiez votre e-mail et votre mot de passe, puis réessayez.",
  "AppOverlayContentView_session_expired_failed_request": "La connexion n'a pas pu être envoyée. Vérifiez votre connexion Internet et réessayez.",
  "AppOverlayContentView_session_expired_login": "Se connecter",
  "AppOverlayContentView_session_expired_login_loading": "Connexion en cours…",
  "AppOverlayContentView_session_expired_password": "Mot de passe",
  "AppOverlayContentView_session_expired_title": "Connexion requise",
  "AppOverlayContentView_ship_close_confirm": "Confirmer la fermeture de LOGBOOK",
  "AppOverlayContentView_ship_close_confirm_cancel": "Annuler",
  "AppOverlayContentView_ship_close_confirm_closing": "Fermeture de LOGBOOK…",
  "AppOverlayContentView_ship_close_confirm_title": "Confirmer la fermeture du navire",
  "AppOverlayContentView_ship_close_failed": "Impossible de fermer LOGBOOK. Vérifiez votre connexion Internet et réessayez.",
  "AppOverlayContentView_ship_close_failed_offline": "LOGBOOK n'a pas pu être fermé car cet appareil est hors ligne. Vérifiez votre connexion Internet et réessayez, ou fermez-le uniquement en local.",
  "AppOverlayContentView_ship_close_failed_server": "LOGBOOK n'a pas pu être fermé car le LOGBOOK Cloud est temporairement indisponible. Veuillez réessayer dans un instant.",
  "AppOverlayContentView_ship_force_close": "Forcer la fermeture locale",
  "AppOverlayContentView_ship_force_close_confirm": "Confirmer la fermeture locale",
  "AppOverlayContentView_ship_view_ships_cloud": "Afficher la liste des navires dans le Cloud",
  "AppOverlayContentView_ships_cloud": "Afficher la liste des navires dans le Cloud",
  "AppOverlayContentView_user_settings": "Paramètres utilisateur",
  "AppOverlayContentView_ship_not_closed_title": "Déconnecter le LOGBOOK Primary \"{name}\" du LOGBOOK Cloud",
  "AppOverlayContentView_ship_open_title": "Le LOGBOOK Primary pour \"{name}\" est déjà ouvert",
  "AppOverlayContentView_read_more": "En savoir plus",

  "ChangeLogView_change_log": "Journal des modifications",
  "ChangeLogView_download": "Télécharger",
  "ChangeLogView_change_welcome": "Bienvenue dans LOGBOOK App Version {version} !",
  "ChangeLogView_change_fixed_info": "Vous trouverez ici des informations sur toutes les modifications apportées. La fenêtre du journal des modifications sera affichée à chaque chargement de l'application s'il y a de nouvelles modifications.",
  "ChangeLogView_new_version_available": "Nouvelle mise à jour disponible au téléchargement",
  "ChangeLogView_title": "Nouveautés dans LOGBOOK",

  "Component_ToggleSwitch": "",
  "Component_ToggleSwitch_off": "OFF",
  "Component_ToggleSwitch_on": "ON",

  "CruiseCalendarView": "",
  "CruiseCalendarView_actions_print": "Imprimer",
  "CruiseCalendarView_focus": "Focus",
  "CruiseCalendarView_start_ship": "Ouvrir le nouveau navire dans l'application LOGBOOK",
  "CruiseCalendarView_open_in_cloud": "Ouvrir dans le Cloud",
  "CruiseCalendarView_untitled_cruise": "Voyage sans titre",

  "CruiseEditView_title": "Nom du voyage",

  "CruiseView": "",
  "CruiseView_actions_print": "Imprimer",
  "CruiseView_empty": "Créer un trajet pour continuer",
  "CruiseView_menu_labels": "Filtrer",
  "CruiseView_menu_toggle_labels_off": "Étiquettes désactivées",
  "CruiseView_menu_toggle_labels_on": "Étiquettes activées",
  "CruiseView_tab_cruise": "Voyage",
  "CruiseView_tab_stats": "Statistiques",
  "CruiseView_tab_track": "Trace",
  "CruiseView_tab_print": "Imprimer",
  "CruiseView_print_cruise": "Imprimer ce voyage",
  "CruiseView_untitled_cruise": "Voyage sans titre",

  "DayEditView": "",
  "DayEditView_comment": "Commentaire",
  "DayEditView_crew": "Équipage",
  "DayEditView_end_location": "Lieu de fin",
  "DayEditView_passengers": "Passagers",
  "DayEditView_skipper": "Capitaine",
  "DayEditView_start_location": "Lieu de départ",
  "DayEditView_status_day": "Jour",
  "DayEditView_status_overnight": "Nuit",
  "DayEditView_sunrise": "Lever du soleil",
  "DayEditView_sunset": "Coucher du soleil",
  "DayEditView_timezone": "Fuseau horaire",
  "DayEditView_other_skipper": "Nouveau capitaine",
  "DayEditView_other_crew": "Nouvelle personne",
  "DayEditView_save_error_generic": "Non enregistré. Veuillez réessayer.",
  "DayEditView_details_last_edited_by": "Dernière modification par {name}",
  "DayEditView_details_last_edited": "Dernière modification",

  "DayHeaderView": "",
  "DayHeaderView_today": "Aujourd'hui",
  "DayHeaderView_nextDay": "Jour suivant",
  "DayHeaderView_yesterday": "Hier",

  "DayView": "",
  "DayView_logs_empty": "Aucun enregistrement pour le moment",
  "DayView_logs_empty_past": "Aucun enregistrement",
  "DayView_tab_day": "Jour",
  "DayView_tab_stats": "Statistiques",
  "DayView_tab_track": "Parcours",
  "DayView_tab_watches": "Plan de quart",
  "DayView_tab_weather": "Météo",
  "DayView_tab_weather_forecast": "Prévisions météo",
  "DayView_tab_journal": "Journal",
  "DayView_tab_technical": "Technique",
  "DayView_tab_print": "Imprimer",
  "DayView_print_days": "Imprimer tous les jours de ce trajet",
  "DayView_print_day": "Imprimer ce jour",

  "DayWatchView": "",
  "DayWatchView_groups_title": "Groupes de quarts",
  "DayWatchView_add_group": "Ajouter un groupe",
  "DayWatchView_groups_name": "Nom du groupe de quart",
  "DayWatchView_groups_people": "Membres d'équipage",

  "DayWatchView_shifts_title": "Plan de quart",
  "DayWatchView_shifts_hour": "Heure",
  "DayWatchView_shifts_duration": "Durée (h)",
  "DayWatchView_shifts_group": "Groupe de quart",
  "DayWatchView_shifts_group_undefined": "*Choisir*",
  "DayWatchView_add_shift": "Ajouter un quart",
  "DayWatchView_reset_shifts": "Réinitialiser les quarts",
  "DayWatchView_shifts_unit_hour": "h",

  "EditHistory": "",
  "EditHistory_title": "Historique des modifications",
  "EditHistory_field": "Champ",
  "EditHistory_previous": "Avant",
  "EditHistory_new": "Après",
  "EditHistory_changed": "Modifié",
  "EditHistory_entry_meta": "{date} par {name}",

  "FocusView": "",
  "FocusView_actions_add_cruise": "Voyage",
  "FocusView_actions_add_trip": "Trajet",
  "FocusView_actions_complete_cruise": "Voyage",
  "FocusView_actions_complete_trip": "Trajet",
  "FocusView_actions_print": "Imprimer",
  "FocusView_start_trip": "Commencer le trajet",
  "FocusView_cancel": "Annuler",
  "FocusView_close": "Fermer",
  "FocusView_confirm": "Continuer",
  "FocusView_confirm_cruise_title": "Commencer un nouveau voyage",
  "FocusView_confirm_trip_title": "Commencer un nouveau trajet",
  "FocusView_set_timezone": "Définir le fuseau horaire",
  "FocusView_tile_new_trip": "Démarrage d'un nouveau trajet",
  "FocusView_timezone": "Fuseau horaire défini pour le trajet",
  "FocusView_current_time": "Heure actuelle calculée",
  "FocusView_subscription_expired": "Abonnement expiré",
  "FocusView_trial_expired": "Phase d'essai terminée",
  "FocusView_view_plans": "Voir les abonnements",

  "GraphView": "",
  "GraphView_graph_pressure": "Pression",
  "GraphView_graph_temperature": "Température",
  "GraphView_graph_windDirection": "Direction du vent",
  "GraphView_graph_windDirection_unit": "{direction}°",
  "GraphView_graph_windSpeed": "Vitesse du vent",
  "GraphView_no_data": "Aucune donnée",

  "InstrumentsView": "",
  "InstrumentsView_compass_title": "Compas",
  "InstrumentsView_compass_title_magnetic": "Compas (mag.)",
  "InstrumentsView_compass_title_true": "Compas (vrai)",
  "InstrumentsView_course_title": "Route",
  "InstrumentsView_depth_title": "Profondeur",
  "InstrumentsView_depth_title_DBK": "Sous la quille",
  "InstrumentsView_depth_title_DBS": "Sous la surface",
  "InstrumentsView_depth_title_DBT": "Sous le transducteur",
  "InstrumentsView_depth_title_DPT": "Eau",
  "InstrumentsView_engine_title_single": "Moteur",
  "InstrumentsView_engine_title_multiple": "Moteurs",
  "InstrumentsView_nmea_lost_title": "Connexion NMEA perdue",
  "InstrumentsView_speed_title": "Vitesse",
  "InstrumentsView_wind_title": "Vent",
  "InstrumentsView_wind_title_apparent": "Apparent",
  "InstrumentsView_wind_title_true": "Vrai",
  "InstrumentsView_wind_title_trueRelative": "Vrai (rel.)",
  "InstrumentsView_wind_side_port": "Bab",
  "InstrumentsView_wind_side_starboard": "Trib",

  "LogEnvironmentView": "",
  "LogEnvironmentView_current_direction_speed": "Courant : Direction | Vitesse",
  "LogEnvironmentView_pressure": "Pression",
  "LogEnvironmentView_save_error_fields": "Non enregistré — non autorisé : {fields}",
  "LogEnvironmentView_save_error_generic": "Non enregistré. Veuillez réessayer.",

  "LogEnvironmentView_seastate": "Condition (mer)",
  "LogEnvironmentView_seastate_undefined": " ",
  "LogEnvironmentView_seastate_": " ",

  "LogEnvironmentView_seastate_0": "0 Calme (miroir)",
  "LogEnvironmentView_seastate_1": "1 Calme (ridée) < 0,1m",
  "LogEnvironmentView_seastate_2": "2 Belle (vaguelettes) < 0,5m",
  "LogEnvironmentView_seastate_3": "3 Peu agitée < 1,25m",
  "LogEnvironmentView_seastate_4": "4 Agitée < 2,5m",
  "LogEnvironmentView_seastate_5": "5 Forte < 4m",
  "LogEnvironmentView_seastate_6": "6 Très forte < 6m",
  "LogEnvironmentView_seastate_7": "7 Grosse < 9m",
  "LogEnvironmentView_seastate_8": "8 Très grosse < 14m",
  "LogEnvironmentView_seastate_9": "9 Énorme > 14m",
  "LogEnvironmentView_seastate_10": "Houle marine irrégulière",
  "LogEnvironmentView_other": "Nouvelle condition (mer)",

  "LogEnvironmentView_current_direction_undefined": " ",
  "LogEnvironmentView_current_direction_": " ",
  "LogEnvironmentView_current_direction_0": "0°",
  "LogEnvironmentView_current_direction_1": "90°",
  "LogEnvironmentView_current_direction_2": "180°",
  "LogEnvironmentView_current_direction_3": "270°",
  "LogEnvironmentView_other_direction": "Autre direction",

  "LogEnvironmentView_weather_": "   ",
  "LogEnvironmentView_weather_field": "Météo",
  "LogEnvironmentView_weather_1": "ciel dégagé",
  "LogEnvironmentView_weather_2": "beau temps",
  "LogEnvironmentView_weather_3": "partiellement nuageux",
  "LogEnvironmentView_weather_4": "nuageux",
  "LogEnvironmentView_weather_5": "couvert",
  "LogEnvironmentView_weather_6": "bruine",
  "LogEnvironmentView_weather_7": "pluie modérée",
  "LogEnvironmentView_weather_8": "forte pluie",
  "LogEnvironmentView_weather_9": "averse",
  "LogEnvironmentView_weather_10": "brume",
  "LogEnvironmentView_weather_11": "brouillard léger",
  "LogEnvironmentView_weather_12": "brouillard",
  "LogEnvironmentView_weather_13": "grésil",
  "LogEnvironmentView_weather_14": "grêle",
  "LogEnvironmentView_weather_15": "orage",
  "LogEnvironmentView_weather_16": "neige",
  "LogEnvironmentView_weather_temp_rel_humidity": "Météo | Temp. | Humidité rel.",
  "LogEnvironmentView_weather_temp": "Température de l'air",
  "LogEnvironmentView_weather_rel_humidity": "Humidité relative",
  "LogEnvironmentView_wind_direction_speed": "Vent : Direction | Vitesse",

  "LogNavigationView": "",
  "LogNavigationView_comment": "Commentaire",
  "LogNavigationView_course": "Route",
  "LogNavigationView_course_to_wind": "Cap au vent",
  "LogNavigationView_point_of_sail_noGo": "Vent debout",
  "LogNavigationView_point_of_sail_closeHauled": "Près",
  "LogNavigationView_point_of_sail_beamReach": "Travers",
  "LogNavigationView_point_of_sail_broadReach": "Largue",
  "LogNavigationView_point_of_sail_running": "Vent arrière",
  "LogNavigationView_wind_side_port": "Bab",
  "LogNavigationView_wind_side_starboard": "Trib",
  "LogNavigationView_depth": "Profondeur",
  "LogNavigationView_distance": "Distance",
  "LogNavigationView_engine": "Moteur",
  "LogNavigationView_engines": "Moteurs",
  "LogNavigationView_engine_name": "Moteur {name}",
  "LogNavigationView_heading": "Cap",
  "LogNavigationView_location": "Emplacement pendant l'arrêt",
  "LogNavigationView_log": "Loch",
  "LogNavigationView_position": "Position : Lat | Lon",
  "LogNavigationView_sails": "Voiles",
  "LogNavigationView_sog": "SOG",
  "LogNavigationView_status": "Statut",
  "LogNavigationView_status_anchor": "Au mouillage",
  "LogNavigationView_status_buoy": "À la bouée",
  "LogNavigationView_status_drifting": "À la dérive",
  "LogNavigationView_status_inmotion": "En mouvement",
  "LogNavigationView_status_none": "Aucun",
  "LogNavigationView_status_offboard": "À terre",
  "LogNavigationView_status_onboard": "À bord",
  "LogNavigationView_status_port": "Au port",
  "LogNavigationView_status_lock": "Écluse",
  "LogNavigationView_status_bunkering": "Station de carburant",
  "LogNavigationView_status_bridge": "Pont",
  "LogNavigationView_status_waiting": "En attente",

  "LogNavigationView_stw": "STW",
  "LogNavigationView_time": "Heure",
  "LogNavigationView_time_utc": "UTC",

  "LogNavigationView_created": "Entrée log créée à",
  "LogNavigationView_updated": "Entrée log mise à jour à",
  "LogNavigationView_engine_rpms": "Régime moteur",
  "LogNavigationView_save_error_fields": "Non enregistré — non autorisé : {fields}",
  "LogNavigationView_save_error_generic": "Non enregistré. Veuillez réessayer.",

  "LogWatchView": "",
  "LogWatchView_watch": "Quart",
  "LogWatchView_watch_comment": "Commentaire de quart",
  "LogWatchView_save_error_generic": "Non enregistré. Veuillez réessayer.",

  "LogView": "",
  "LogView_details_created_by": "Créé par {name}",
  "LogView_details_updated_at": "Dernière mise à jour le {date}",
  "LogView_details_last_edited_by": "Dernière modification par {name}",
  "LogView_details_last_edited": "Dernière modification",
  "LogView_label_auto": "auto",
  "LogView_label_default": "défaut",
  "LogView_label_manual": "manuel",
  "LogView_label_nmea": "nmea",
  "LogView_log_alert": "Alerte {status} : {type} {info}",
  "LogView_log_alert_info_anchorDepth": "- {depth}",
  "LogView_log_alert_info_anchorDrift": "- dérivé de {distance} du point de mouillage",
  "LogView_log_alert_info_pressure": "- {action} de {delta} en {interval}",
  "LogView_log_alert_info_pressure_drop": "chutée",
  "LogView_log_alert_info_pressure_raise": "augmentée",
  "LogView_log_alert_anchorDrift": "Dérive du mouillage",
  "LogView_log_alert_depth": "Profondeur",
  "LogView_log_alert_lights": "Feux de navigation",
  "LogView_log_alert_lostPosition": "Position perdue",
  "LogView_log_alert_manOverboard": "Homme à la mer",
  "LogView_log_alert_message": "Message",
  "LogView_log_alert_pressure": "Pression",
  "LogView_log_alert_test": "Test",
  "LogView_log_alert_wind": "Vent",
  "LogView_log_alert_start": "L'alerte {alert} est {status}",
  "LogView_log_alert_triggered": "Alerte {alert} déclenchée",
  "LogView_log_alert_anchorDrift_detail": "{transition} : {problem}",
  "LogView_log_alert_depth_detail": "{transition} : {problem}",
  "LogView_log_alert_lostPosition_detail": "{transition} : {problem}",
  "LogView_log_alert_manOverboard_detail": "{transition} : {problem}",
  "LogView_log_alert_message_detail": "{transition} : {problem}",
  "LogView_log_alert_lostPosition_disconnected": "NMEA déconnecté",
  "LogView_log_alert_lostPosition_stale": "données de position périmées",
  "LogView_log_alert_lostPosition_jump": "saut de position improbable",
  "LogView_log_alert_lostPosition_invalidFix": "position GPS invalide",
  "LogView_log_alert_manOverboard_emitterActivated": "balise MOB activée",
  "LogView_log_alert_manOverboard_manualButtonActivated": "bouton MOB activé",
  "LogView_log_alert_manOverboard_manual": "déclenchée manuellement",
  "LogView_log_alert_manOverboard_unknown": "signal MOB reçu",
  "LogView_log_alert_lights_detail": "{recorded} -> {recommended}: {transition}.",
  "LogView_log_alert_escalated": "Alerte {alert} escaladée",
  "LogView_log_alert_escalated_by": "Alerte {alert} escaladée au skipper par {name}",
  "LogView_log_alert_snoozed": "Alerte {alert} mise en veille",
  "LogView_log_alert_snoozed_by": "Alerte {alert} mise en veille par {name}",
  "LogView_log_alert_acknowledged": "Alerte {alert} acquittée",
  "LogView_log_alert_acknowledged_by": "Alerte {alert} acquittée par {name}",
  "LogView_log_alert_cleared": "Alerte {alert} effacée",
  "LogView_log_alert_cleared_by": "Alerte {alert} effacée par {name}",
  "LogView_log_alert_resolved": "Alerte {alert} résolue",
  "LogView_log_alert_status_acknowledged": "Acquittée",
  "LogView_log_alert_status_alarm": "Alarme",
  "LogView_log_alert_status_ignored": "Ignorée",
  "LogView_log_alert_status_ok": "OK",
  "LogView_log_alert_status_resolved": "Résolue",
  "LogView_log_alert_status_warning": "Avertissement",
  "LogView_log_alert_type_anchorDepth": "Profondeur au mouillage",
  "LogView_log_alert_type_anchorDrift": "Dérive du mouillage",
  "LogView_log_alert_type_pressure": "Pression",
  "LogView_log_auto_interval": "Entrée automatique après {duration}",
  "LogView_log_change_add_crew": "Ajouté à l'équipage : {name}",
  "LogView_log_change_add_passengers": "Ajouté aux passagers : {name}",
  "LogView_log_change_add_skipper": "Ajouté au capitaine : {name}",
  "LogView_log_change_remove_crew": "Retiré de l'équipage : {name}",
  "LogView_log_change_remove_passengers": "Retiré des passagers : {name}",
  "LogView_log_change_remove_skipper": "Retiré du capitaine : {name}",
  "LogView_log_course_change": "Changement de route",
  "LogView_log_course_change_active": "Changement de route de {angle} {side} en {duration} vers {course}",
  "LogView_log_course_change_end": "Changement de route de {angle} {side} en {duration} depuis {course}",
  "LogView_log_course_change_side_port": "à bâbord",
  "LogView_log_course_change_side_starboard": "à tribord",
  "LogView_log_course_change_started": "Changement de route commencé",
  "LogView_log_engine_start": "Moteur démarré",
  "LogView_log_engine_start_name": "Moteur {name} démarré",
  "LogView_log_engine_start_idle": "Moteur démarré au ralenti",
  "LogView_log_engine_start_idle_name": "Moteur {name} démarré au ralenti",
  "LogView_log_engine_stop": "Moteur arrêté",
  "LogView_log_engine_stop_name": "Moteur {name} arrêté",
  "LogView_log_engine_stop_duration": "Moteur arrêté après {duration}",
  "LogView_log_engine_stop_duration_name": "Moteur {name} arrêté après {duration}",
  "LogView_log_engine_stop_distance": "Moteur arrêté après {duration} ({distance})",
  "LogView_log_engine_stop_distance_name": "Moteur {name} arrêté après {duration} ({distance})",
  "LogView_log_engine_idle": "Moteur au ralenti",
  "LogView_log_engine_idle_name": "Moteur {name} au ralenti",
  "LogView_log_engine_load": "Moteur en charge",
  "LogView_log_engine_load_name": "Moteur {name} en charge",
  "LogView_log_engine_load_duration": "Moteur en charge après {duration}",
  "LogView_log_engine_load_duration_name": "Moteur {name} en charge après {duration}",
  "LogView_log_engine_missing": "Informations moteur manquantes, présumé arrêté",
  "LogView_log_engine_missing_name": "Informations moteur {name} manquantes, présumé arrêté",
  "LogView_log_engine_missing_duration": "Informations moteur manquantes, présumé arrêté après {duration}",
  "LogView_log_engine_missing_duration_name": "Informations moteur {name} manquantes, présumé arrêté après {duration}",
  "LogView_log_engine_missing_distance": "Informations moteur manquantes, présumé arrêté après {duration} ({distance})",
  "LogView_log_engine_missing_distance_name": "Informations moteur {name} manquantes, présumé arrêté après {duration} ({distance})",
  "LogView_log_propulsion_off": "Sous voiles, aucun moteur en marche",
  "LogView_log_propulsion_off_noSails": "Aucun moteur en marche",
  "LogView_log_engine_missing_hint_castOff": "Entrée moteur manquante depuis l'appareillage ?",
  "LogView_log_engine_missing_hint_anchorUp": "Entrée moteur manquante depuis le levage de l'ancre ?",
  "LogView_log_engine_missing_hint_motorVessel": "Entrée moteur manquante depuis le départ ?",
  "LogView_log_generator_start": "Générateur {number} démarré",
  "LogView_log_generator_stop": "Générateur {number} arrêté",
  "LogView_log_lighting": "Feux réglés sur {lighting}",
  "LogView_log_lighting_none": "Aucun feu affiché",
  "LogView_log_monitor_start": "Surveillance {monitor} démarrée",
  "LogView_log_monitor_stop": "Surveillance {monitor} arrêtée",
  "LogView_log_monitor_anchor": "Alarme de mouillage",
  "LogView_log_monitor_depth": "de la profondeur",
  "LogView_log_navigation_status_start": "Navigation commencée",
  "LogView_log_navigation_status_stop": "Navigation arrêtée",
  "LogView_log_nmea_connection_resume": "Connexion NMEA rétablie pour les données de navigation",
  "LogView_log_nmea_connection_stop": "Connexion NMEA perdue pour les données de navigation",
  "LogView_log_nmea_connection_start": "Connexion NMEA démarrée pour",
  "LogView_log_nmea_connection_user_stop": "Connexion NMEA fermée pour les données de navigation",
  "LogView_log_pause_start": "Début de la pause",
  "LogView_log_pause_stop": "Fin de la pause",
  "LogView_log_pause_stop_duration": "Fin de la pause après {duration}",
  "LogView_log_pause_stop_status": "{status} terminé",
  "LogView_log_pause_stop_status_duration": "{status} terminé après {duration}",
  "LogView_log_status_anchor": "Au mouillage",
  "LogView_log_status_bunkering": "À la station-service",
  "LogView_log_status_buoy": "À la bouée",
  "LogView_log_status_drifting": "À la dérive",
  "LogView_log_status_inmotion": "En mouvement",
  "LogView_log_status_offboard": "À terre",
  "LogView_log_status_onboard": "À bord",
  "LogView_log_status_port": "Au port",
  "LogView_log_status_lock": "Dans l'écluse",
  "LogView_log_status_bridge": "Au pont",
  "LogView_log_status_waiting": "En attente",
  "LogView_log_status_location": "{status} : {location}",
  "LogView_log_stop": "Arrêt pour {stop}",
  "LogView_log_stop_location": "Arrêt pour {stop} à {location}",
  "LogView_log_stop_type_endOfDay": "fin de journée",
  "LogView_log_stop_type_stopover": "escale",
  "LogView_log_sail_down": "{sail} affalée",
  "LogView_log_sail_up": "{sail} hissée",

  "LogView_nmea_auto_course_change_entries": "Entrées de changement de route",
  "LogView_nmea_auto_entries": "Entrées automatiques",
  "LogView_nmea_pending": "Log",
  "LogView_provisional_cancel_discard": "Supprimer l'entrée",
  "LogView_provisional_cancel_error": "L'entrée n'a pas pu être supprimée. Veuillez réessayer.",
  "LogView_provisional_cancel_keep": "Conserver",
  "LogView_provisional_cancel_message_courseChange": "Supprimer ce changement de route ? Aucune entrée ne sera enregistrée pour cette manœuvre.",
  "LogView_provisional_cancel_message_speedChange": "Supprimer cette pause ? Aucune entrée ne sera enregistrée et le navire reste en route.",
  "LogView_provisional_cancel_title_courseChange": "Supprimer le changement de route",
  "LogView_provisional_cancel_title_speedChange": "Supprimer la pause",
  "LogView_tab_environment": "Environnement",
  "LogView_tab_navigation": "Navigation",
  "LogView_tab_watch": "Quart",

  "LoginView": "",
  "LoginView_error_confirmation_failed": "La confirmation de l'e-mail a échoué. Si le compte a été précédemment activé, vous pouvez utiliser la fonction Mot de passe oublié ci-dessous.",
  "LoginView_error_failed": "La connexion a échoué. Veuillez vérifier votre e-mail et votre mot de passe et réessayer.",
  "LoginView_error_failed_request": "La connexion a échoué. Veuillez vérifier votre connexion Internet et réessayer.",
  "LoginView_error_native_login_failed": "La connexion n'a pas pu être finalisée. Veuillez revenir dans l'application et réessayer.",
  "LoginView_local_login_required": "Ouvrez LOGBOOK sur cet appareil pour vous connecter. La connexion Primary est uniquement disponible dans l'application locale de cet appareil.",
  "LoginView_companion_handoff_failed": "La connexion Companion n'a pas pu être établie. Ouvrez LOGBOOK sur cet appareil et reconnectez-vous depuis votre liste de bateaux.",
  "LoginView_companion_handoff_pending": "Connexion au LOGBOOK Primary...",
  "LoginView_error_native_login_invalid": "La connexion ne peut pas continuer, car le rappel de l'application est absent ou non valide.",
  "LoginView_error_signup_failed": "L'inscription a échoué.",
  "LoginView_error_signupEmailAlreadyExists": "L'inscription a échoué. L'adresse e-mail est déjà utilisée.",
  "LoginView_error_signupAccountAlreadyExists": "L'inscription a échoué. Un compte avec le même nom existe déjà.",
  "LoginView_error_signupNameInvalid": "Merci de saisir votre nom (au moins 3 caractères).",
  "LoginView_error_signupEmailInvalid": "Merci de saisir une adresse e-mail valide.",
  "LoginView_error_signupPasswordInvalid": "Le mot de passe doit contenir au moins 3 caractères.",
  "LoginView_error_invitation_accept_failed": "L'acceptation de l'invitation a échoué. Veuillez vous assurer que vous êtes connecté avec le compte auquel l'invitation a été envoyée, puis réessayez.",
  "LoginView_forgot_password": "Récupération du mot de passe",
  "LoginView_forgot_password_complete": "Mot de passe modifié. Vous pouvez maintenant vous connecter à votre compte en utilisant le nouveau mot de passe.",
  "LoginView_forgot_password_email": "Veuillez entrer l'adresse e-mail de votre compte pour démarrer le processus de récupération du mot de passe.",
  "LoginView_forgot_password_email_sent": "Si un compte existe pour cette adresse e-mail, vous recevrez un e-mail avec les prochaines étapes.",
  "LoginView_forgot_password_new_password": "Veuillez entrer un nouveau mot de passe pour terminer la récupération du mot de passe.",
  "LoginView_error_reset_failed": "La récupération du mot de passe a échoué. Veuillez réessayer.",
  "LoginView_error_reset_failed_request": "La récupération du mot de passe a échoué. Veuillez vérifier votre connexion Internet et réessayer.",
  "LoginView_form_back_to_login": "Retour à la page de connexion",
  "LoginView_form_name": "Nom",
  "LoginView_form_email": "E-mail",
  "LoginView_form_new_password": "Nouveau mot de passe",
  "LoginView_form_new_password_confirmation": "Confirmation du nouveau mot de passe",
  "LoginView_form_password": "Mot de passe",
  "LoginView_form_submit": "Connexion",
  "LoginView_form_submit_forgot_password": "Réinitialiser",
  "LoginView_form_submit_forgot_password_loading": "Réinitialisation…",
  "LoginView_form_submit_login": "Connexion",
  "LoginView_form_submit_login_loading": "Connexion en cours…",
  "LoginView_form_submit_signup": "S'inscrire",
  "LoginView_form_forgot_password": "Mot de passe\u00A0oublié ?",
  "LoginView_form_account_name": "Nom du compte",

  "LoginView_reset_app_title": "Réinitialiser l'application",
  "LoginView_reset_app_cancel": "Annuler",
  "LoginView_reset_app_action": "Démarrer la réinitialisation",

  "LoginView_welcome": "Bienvenue sur LOGBOOK.",
  "LoginView_signup_link_unavailable": "Le lien d'inscription n'a pas pu être chargé. Veuillez réessayer.",
  "LoginView_signup_link_retry": "Réessayer",
  "LoginView_login": "Vous avez déjà un compte ? Connectez-vous simplement à LOGBOOK.",
  "LoginView_login_email": "Connectez-vous avec votre e-mail et votre mot de passe.",
  "LoginView_native_sign_in_loading": "Connexion…",
  "LoginView_native_sign_in_fallback": "Se connecter avec Safari",
  "LoginView_native_sign_in_or": "ou",
  "LoginView_signup": "Vous êtes nouveau sur LOGBOOK ? Inscrivez-vous simplement pour LOGBOOK.",
  "LoginView_signup_email": "Inscrivez-vous avec votre e-mail et un mot de passe.",
  "LoginView_invitation_use_other_account": "Utiliser un autre compte",
  "LoginView_invitation_accept": "Accepter l'invitation",
  "LoginView_footer_about": "À propos de nous",
  "LoginView_footer_help": "Aide",
  "LoginView_footer_language": "Langue",
  "LoginView_footer_reset_app": "Réinitialiser l'application",

  "Menu": "",
  "Menu_ship": "Navire",
  "Menu_account": "Compte",

  "MenuAccount": "",
  "MenuAccount_account_settings": "Paramètres\u00A0du compte",
  "MenuAccount_remove_account": "Supprimer le compte",
  "MenuAccount_close_companion": "Déconnecter le Companion",
  "MenuAccount_open_cloud": "Vers LOGBOOK\u00A0Cloud",
  "MenuAccount_account_settings_app": "Vers l'application\u00A0LOGBOOK",
  "MenuAccount_logout": "Déconnexion",
  "MenuAccount_switch_user": "Changer d'utilisateur",
  "MenuAccount_return_to_own_user": "Retour à {name}",
  "MenuAccount_user_settings": "Paramètres\u00A0utilisateur",

  "MenuHelp": "",
  "MenuHelp_about": "À propos\u00A0de LOGBOOK",
  "MenuHelp_change_log": "Journal des modifications",
  "MenuHelp_contact_support": "Contacter\u00A0l'assistance",
  "MenuHelp_documentation": "Documentation",
  "MenuHelp_help": "Aide",
  "MenuHelp_support": "Page d'assistance",
  "MenuHelp_qanda": "Questions et réponses",
  "MenuHelp_demo": "Démos interactives",
  "MenuHelp_title": "Aide",

  "MenuAlerts": "",
  "MenuAlerts_title": "Alertes",

  "MenuNMEA": "",
  "MenuNMEA_connection": "Connexion NMEA",
  "MenuNMEA_last_update": "Dernière mise à jour : {timestamp}",
  "MenuNMEA_recording": "Enregistrement automatique",
  "MenuNMEA_settings": "Paramètres",
  "MenuNMEA_title": "NMEA",

  "MenuShip": "",
  "MenuShip_close": "Fermer LOGBOOK {name}",
  "MenuShip_logout": "Déconnexion de \"{name}\"",
  "MenuShip_data_name": "Données du navire {name}",
  "MenuShip_new": "Nouveau navire",
  "MenuShip_settings_name": "Paramètres de {name}",
  "MenuShip_select": "Sélectionner un navire",
  "MenuShip_view_cloud": "Voir \"{name}\" dans le Cloud",
  "MenuShip_view_ships": "Voir la liste des navires",

  "MenuSync": "",
  "MenuSync_internet_status": "Connexion\u00A0Internet",
  "MenuSync_last_update": "Dernière mise à jour : {timestamp}",
  "MenuSync_status": "État de synchronisation",
  "MenuSync_title": "Sync",
  "MenuSync_resync": "Reconnecter",
  "MenuSync_relogin": "Se reconnecter",

  "NMEAConfigurationView": "",
  "NMEAConfigurationView_blank": "\u00A0",
  "NMEAConfigurationView_and": "et",
  "NMEAConfigurationView_banner_start_setup": "Démarrer la configuration NMEA",
  "NMEAConfigurationView_banner_text": "La connexion NMEA n'est pas activée.",
  "NMEAConfigurationView_cancel": "Annuler",
  "NMEAConfigurationView_checks": "Données NMEA disponibles :",
  "NMEAConfigurationView_check_air_pressure": "Pression atmosphérique",
  "NMEAConfigurationView_check_air_humidity": "Humidité",
  "NMEAConfigurationView_check_air_temperature": "Température de l'air",
  "NMEAConfigurationView_check_depth": "Profondeur",
  "NMEAConfigurationView_check_engine": "Régime moteur",
  "NMEAConfigurationView_check_engine_1": "Régime moteur #1",
  "NMEAConfigurationView_check_engine_2": "Régime moteur #2",
  "NMEAConfigurationView_check_engine_3": "Régime moteur #3",
  "NMEAConfigurationView_check_engine_4": "Régime moteur #4",
  "NMEAConfigurationView_check_engine_5": "Régime moteur #5",
  "NMEAConfigurationView_check_engine_ids": "ID moteurs actifs : {ids}",
  "NMEAConfigurationView_check_engine_ids_none": "aucun",
  "NMEAConfigurationView_check_navigation_course": "Cap",
  "NMEAConfigurationView_check_navigation_gps": "Position GPS",
  "NMEAConfigurationView_check_navigation_log": "Distance dans l'eau",
  "NMEAConfigurationView_check_navigation_sog": "Vitesse sur le fond",
  "NMEAConfigurationView_check_utc": "UTC",
  "NMEAConfigurationView_check_water_temperature": "Température de l'eau",
  "NMEAConfigurationView_check_native_gps": "Position GPS interne",
  "NMEAConfigurationView_check_native_air_pressure": "Pression atmosphérique interne",
  "NMEAConfigurationView_check_wind": "Vent (vitesse et direction)",
  "NMEAConfigurationView_connection_device": "Appareil",
  "NMEAConfigurationView_connection_host": "Adresse",
  "NMEAConfigurationView_connection_port": "Port",
  "NMEAConfigurationView_connection_type": "Type de connexion NMEA",
  "NMEAConfigurationView_connection_type_bluetooth": "Bluetooth (non pris en charge)",
  "NMEAConfigurationView_connection_type_gps": "GPS intégré",
  "NMEAConfigurationView_connection_type_tcp": "TCP",
  "NMEAConfigurationView_connection_type_udp": "UDP",
  "NMEAConfigurationView_connection_type_usb": "USB",
  "NMEAConfigurationView_connect": "Tester la connexion",
  "NMEAConfigurationView_connecting": "Connexion…",
  "NMEAConfigurationView_capture": "Envoyer les données NMEA au support",
  "NMEAConfigurationView_capture_sending": "Envoi...",
  "NMEAConfigurationView_capture_success": "Envoyé",
  "NMEAConfigurationView_capture_error": "Échec de l’envoi",
  "NMEAConfigurationView_capture_hint": "Envoie un court enregistrement des données brutes reçues de vos instruments, afin que le support puisse analyser les problèmes de connexion.",
  "NMEAConfigurationView_complete": "Terminé",
  "NMEAConfigurationView_error_invalidUrl": "Erreur : URL invalide",
  "NMEAConfigurationView_error_connectionFailed": "Erreur : Échec de la connexion",
  "NMEAConfigurationView_error_disconnected": "Erreur : NMEA n'est pas connecté",
  "NMEAConfigurationView_error_failedToOpen": "Erreur : Échec de l'ouverture de l'appareil",
  "NMEAConfigurationView_error_subscriptionExpired": "Erreur : Abonnement expiré",
  "NMEAConfigurationView_error_unsupportedSchema": "Erreur : Protocole non pris en charge",
  "NMEAConfigurationView_reconnect": "Reconnecter",
  "NMEAConfigurationView_reset": "Réinitialiser",
  "NMEAConfigurationView_step_conditions": "Conditions",
  "NMEAConfigurationView_step_connection": "Connexion",
  "NMEAConfigurationView_step_native": "Capteurs internes",
  "NMEAConfigurationView_step_test_data": "Test et données",
  "NMEAConfigurationView_title": "Paramètres NMEA",
  "NMEAConfigurationView_read_more": "En savoir plus",
  "NMEAConfigurationView_condition_entry": "Conditions pour les entrées automatiques du journal",
  "NMEAConfigurationView_condition_interval": "Entrées régulières toutes les ",
  "NMEAConfigurationView_condition_interval_3600": "60 min ",
  "NMEAConfigurationView_condition_interval_1800": "30 min ",

  "NMEAConfigurationView_condition_start_stop": "Condition pour l'entrée de départ/arrêt",
  "NMEAConfigurationView_condition_anchor_start_stop": "Paramètre différent à l'ancre ou à la bouée",
  "NMEAConfigurationView_condition_anchor_no_status_change": "Aucun changement de statut si la vitesse est",
  "NMEAConfigurationView_condition_anchor_depth_alerts": "Alertes d'ancre et de profondeur",
  "NMEAConfigurationView_condition_anchor_drift_warning": "Avertissement de dérive d'ancre (nm)",
  "NMEAConfigurationView_condition_anchor_drift_alarm": "Alarme de dérive d'ancre (nm)",
  "NMEAConfigurationView_condition_depth_warning": "Avertissement de profondeur",
  "NMEAConfigurationView_condition_depth_alarm": "Alarme de profondeur",
  "NMEAConfigurationView_condition_stop": "Entrée d'arrêt si vitesse",
  "NMEAConfigurationView_condition_start": "Entrée de départ si vitesse",
  "NMEAConfigurationView_condition_course": "Entrée lors d'un changement de route lorsque ",
  "NMEAConfigurationView_condition_course_change": "changement de cap",
  "NMEAConfigurationView_condition_course_speed": "vitesse",
  "NMEAConfigurationView_condition_native_gps": "Utiliser le GPS interne",
  "NMEAConfigurationView_condition_native_pressure": "Utiliser le capteur de pression atmosphérique interne",
  "NMEAConfigurationView_condition_engine_idle_rpm": "Si le moteur fonctionne à moins que le régime au ralenti (tr/min) : compter le temps et la distance comme \"sous voile\".",
  "NMEAConfigurationView_condition_engine_idle_rpm_value": "Régime au ralenti (tr/min)",
  "NMEAConfigurationView_condition_engine_detection": "Détection du moteur (tr/min)",
  "NMEAConfigurationView_condition_engine_start": "Moteur en marche lorsque le régime dépasse",
  "NMEAConfigurationView_condition_engine_stop": "Moteur arrêté lorsque le régime est en dessous de",
  "NMEAConfigurationView_error_engine_rpm_order": "Erreur : le régime \"moteur arrêté\" doit être inférieur au régime \"moteur en marche\"",
  "NMEAConfigurationView_error_engine_idle_rpm": "Erreur : le régime au ralenti doit être supérieur au régime \"moteur en marche\"",
  
  "NoteView": "",
  "NoteView_planning": "Plan de voyage",
  "NoteView_crew": "Équipage",
  "NoteView_day": "Jour",
  "NoteView_file_field_drag_drop": "Joindre des fichiers à cette note.",
  "NoteView_attachment_remove_confirm": "Voulez-vous vraiment supprimer cette pièce jointe ?",
  "NoteView_attachment_remove_title": "Supprimer la pièce jointe",
  "NoteView_attachment_remove_accept": "Supprimer",
  "NoteView_attachment_remove_cancel": "Annuler",
  "NoteView_attachment_remove_error": "Impossible de supprimer la pièce jointe. Veuillez réessayer.",
  "NoteView_journal": "Journal",
  "NoteView_note_created_by": "Créé par {name}",
  "NoteView_note_parent_day": "Jour : {date}",
  "NoteView_note_parent_trip": "Trajet : {name}",
  "NoteView_other": "Autre",
  "NoteView_technical": "Technique",
  "NoteView_type": "Type",
  "NoteView_weather": "Prévisions météo",
  "NoteView_show_notes": "Afficher {count} notes {type}",
  "NoteView_watch": "Plan de quart",

  "NoteView_note_add_new": "Ajouter une nouvelle note",

  "NoteView_note_journal_title": "Titre de l'entrée de journal",
  "NoteView_note_journal_note": "Texte du journal",

  "NoteView_note_planning_date": "Date",
  "NoteView_note_planning_title": "Emplacement",
  "NoteView_note_planning_note": "Commentaire",

  "NoteView_note_technical_title": "Titre de la note technique",
  "NoteView_note_technical_note": "Note technique",

  "NoteView_note_parent_type_day": "jour",
  "NoteView_note_parent_type_trip": "trajet",

  "NoteView_note_weather_title": "Source",
  "NoteView_note_weather_date": "Date et heure",
  "NoteView_note_weather_note": "Prévisions météo",
  "NoteView_note_weather_note_extra": "Conditions météo",

  "PrintHeaderView": "",
  "PrintHeaderView_title": "LOGBOOK {view} – {ship}",
  "PrintHeaderView_print_1": "Vue d'ensemble du voyage",
  "PrintHeaderView_print_2": "Trajets sélectionnés",
  "PrintHeaderView_print_3": "Jours sélectionnés",
  "PrintHeaderView_print_4": "Données du navire",
  "PrintHeaderView_motor": "Navire à moteur",
  "PrintHeaderView_sailing": "Voilier",

  "PrintSettingsView": "",
  "PrintSettingsView_title": "Paramètres d'impression",
  "PrintSettingsView_button": "Imprimer",
  "PrintSettingsView_cancel": "Annuler",
  "PrintSettingsView_overview": "Aperçu de l'impression",
  "PrintSettingsView_overview_all": "Imprimer tous les voyages dans LOGBOOK",
  "PrintSettingsView_overview_year": "Sélectionner une année",
  "PrintSettingsView_overview_cruises": "Imprimer l'aperçu des voyages",

  "PrintSettingsView_cruise": "Imprimer le voyage",
  "PrintSettingsView_cruise_current": "Imprimer toutes les données du voyage suivies d'une liste de tous les trajets",
  "PrintSettingsView_cruise_summary": "Données du voyage et liste des trajets",
  "PrintSettingsView_cruise_details": "Détails du voyage",

  "PrintSettingsView_ship": "Imprimer les données du navire",
  "PrintSettingsView_ship_short": "Données principales du navire",
  "PrintSettingsView_ship_details": "Données détaillées du navire",
  "PrintSettingsView_user_list": "Imprimer toutes les personnes pour ce navire",

  "PrintSettingsView_trip": "Trajets",
  "PrintSettingsView_trips": "Imprimer les trajets",
  "PrintSettingsView_trips_all": "Imprimer tous les trajets du voyage",
  "PrintSettingsView_trips_selected": "Sélectionner un trajet à imprimer",
  "PrintSettingsView_timeline": "Chronologie",
  "PrintSettingsView_trips_summary": "Imprimer toutes les données des trajets et",
  "PrintSettingsView_trips_summary_details": "une liste de jours avec détails",
  "PrintSettingsView_trips_summary_short": "une liste courte de jours",
  "PrintSettingsView_trips_details": "Détails du trajet",
  "PrintSettingsView_journal_list": "Imprimer toutes les entrées de journal (trajets et jours)",
  "PrintSettingsView_technical_list": "Imprimer toutes les entrées techniques (trajets et jours)",

  "PrintSettingsView_days": "Imprimer les jours",
  "PrintSettingsView_days_select": "Sélectionner un seul jour",
  "PrintSettingsView_days_trip_select": "Imprimer tous les jours du trajet sélectionné",
  "PrintSettingsView_days_text": "Imprimer les données du jour : onglets Jour et Statistiques plus les onglets choisis ci-dessous :",
  "PrintSettingsView_thumbnails": " (y compris les miniatures d'images)",

  "PrintSettingsView_entries": "Ajouter également les entrées log chaque jour",
  "PrintSettingsView_edits": "Inclure toutes les modifications des entrées log et sur l'onglet du jour",
  "PrintSettingsView_entries_summary": "Résumé (liste des entrées log)",
  "PrintSettingsView_entries_details": "Entrées log détaillées",
  "PrintSettingsView_entries_day_select": "Sélectionner un jour",
  "PrintSettingsView_entries_trip_select": "Sélectionner un trajet pour imprimer les jours",

  "PrintSettingsView_evaluations": "Imprimer les évaluations",
  "PrintSettingsView_journal": "Entrées de journal avec photos",
  "PrintSettingsView_tacks": "Traces",
  "PrintSettingsView_technical": "Documentation technique avec photos",

  "PrintSettingsView_authorities": "Évaluation pour les autorités",
  "PrintSettingsView_authorities_day": "Entrées manuelles pour la journée",
  "PrintSettingsView_authorities_log": "Entrées log",

  "PrintView": "",
  "PrintView_print_action": "Imprimer",
  "PrintView_print_cancel": "Annuler",
  "PrintView_cruise": "Voyage",
  "PrintView_cruise_statistics": "Statistiques du voyage",
  "PrintView_trip": "Trajet",
  "PrintView_trips": "Trajet",

  "PrintView_trip_list": "Liste des trajets",
  "PrintView_trip_statistics": "Statistiques du trajet",
  "PrintView_day": "Données du journal de bord pour",
  "PrintView_day_list": "Liste des jours dans le trajet",
  "PrintView_day_maindata": "Données principales du jour",
  "PrintView_day_statistics": "Statistiques du jour",
  "PrintView_date": "Date",
  "PrintView_from_date": "Du",
  "PrintView_until_date": "jusqu'au",
  "PrintView_from_loc": "En provenance de",
  "PrintView_to_loc": "vers",
  "PrintView_time_total": "Durée",
  "PrintView_distance_total": "Distance",
  "PrintView_technical_notes": "Notes techniques",

  "PrintView_watch_groups": "Groupes de quart",
  "PrintView_watch_shifts": "Quarts",

  "PrintView_note_technical": "Note technique",
  "PrintView_list_technical": "Liste de toutes les notes techniques",
  "PrintView_note_journal": "Entrée de journal",
  "PrintView_list_journal": "Liste de toutes les entrées de journal",

  "PrintView_note_watch": "Quart",
  "PrintView_note_planning": "Plan de voyage",
  "PrintView_note_weather": "Prévisions météo",

  "PrintView_log_entries": "Entrées de journal",

  "SearchView": "",
  "SearchView_token_ship": "Navire",
  "SearchView_token_type": "Type",
  "SearchView_type_cruise": "Voyage",
  "SearchView_type_day": "Jour",
  "SearchView_type_log": "Log",
  "SearchView_type_note": "Note",
  "SearchView_type_trip": "Trajet",

  "ShipImportView": "",
  "ShipImportView_cancel": "Annuler",
  "ShipImportView_file_field_drag_drop": "Sélectionner le fichier d'exportation LogbookSuite",
  "ShipImportView_open": "Voir le navire",
  "ShipImportView_status_complete": "Terminé",
  "ShipImportView_status_failed": "Échec. Veuillez réessayer ou contacter l'assistance pour obtenir de l'aide.",
  "ShipImportView_status_error": "Erreur : {error}",
  "ShipImportView_status_processing": "Traitement en cours",
  "ShipImportView_status_pending": "Préparation de l'importation",
  "ShipImportView_status_uploading": "Téléchargement",
  "ShipImportView_title": "Importer les données du navire",
  "ShipImportView_title_ship": "Importer les trajets dans {ship}",

  "ShipSettingsView_settings": "Paramètres",
  "ShipSettingsView_ship_settings": "Paramètres du navire",
  "ShipSettingsView_tab_units": "Paramètres des unités",
  "ShipSettingsView_tab_ship_user": "Toutes les personnes",
  "ShipSettingsView_tab_lists": "Paramètres des listes",
  "ShipSettingsView_tab_settings": "Paramètres",
  "ShipSettingsView_tab_companions": "Companions",
  "ShipSettingsView_more_info": "En savoir plus", 
  "ShipSettingsView_read_more": "En savoir plus", 
  "ShipSettingsView_add_user": "Personne",
  "ShipSettingsView_cancel": "Annuler",
  "ShipSettingsView_save": "Ajouter une personne",
  "ShipSettingsView_timezone": "Fuseau horaire",
  "ShipSettingsView_timezone_title": "Configuration manuelle du fuseau horaire",
  "ShipSettingsView_timezone_manual": "Définir le fuseau horaire manuellement",
  "ShipSettingsView_current_time": "Heure actuelle",
  "ShipSettingsView_log_offset_title": "Décalage pour la valeur du transducteur de loch",
  "ShipSettingsView_log_offset": "Décalage du loch (nm)",
  "ShipSettingsView_rpm_title": "Conserver le RPM saisi manuellement",
  "ShipSettingsView_rpm_keep_manual": "Reporter le RPM à la prochaine entrée de journal",
  "ShipSettingsView_lights_title": "Rappel des signaux visuels",
  "ShipSettingsView_lights_enable": "Me rappeler les signaux visuels",
  "ShipSettingsView_lights_sailing": "Feux portés à la voile",
  "ShipSettingsView_lights_sailing_runningLights": "Feux de navigation séparés",
  "ShipSettingsView_lights_sailing_triColor": "Feu tricolore en tête de mât",
  "ShipSettingsView_lights_lead": "Limite jour / nuit",
  "ShipSettingsView_lights_lead_civil": "Crépuscule civil (recommandé)",
  "ShipSettingsView_lights_lead_official": "Coucher / lever du soleil",
  "ShipSettingsView_lights_motoring_cone": "Me rappeler de hisser le cône de moteur",
  "ShipSettingsView_edit_permissiveness_title": "Permissivité d'édition",
  "ShipSettingsView_edit_permissiveness_level": "Niveau d'édition",
  "ShipSettingsView_edit_permissiveness_level_default": "Par défaut (strict)",
  "ShipSettingsView_edit_permissiveness_level_extended": "Étendu",
  "ShipSettingsView_edit_permissiveness_level_unrestricted": "Illimité",
  "ShipSettingsView_socket": "Adresse du LOGBOOK Primary",
  "ShipSettingsView_socket_text": "Utilisez cette adresse pour connecter un Companion au LOGBOOK Primary",
  "ShipSettingsView_connected_companions": "Companions connectés",
  "ShipSettingsView_companion_host": "Hôte",
  "ShipSettingsView_companion_user": "Utilisateur",
  "ShipSettingsView_companions_loading": "Chargement des Companions connectés…",
  "ShipSettingsView_companions_empty": "Aucun Companion n’est actuellement connecté.",
  "ShipSettingsView_companions_error": "Impossible de charger les Companions connectés. Nouvelle tentative…",
  "ShipSettingsView_disconnect_companion": "Déconnecter",
  "ShipSettingsView_disconnect_companion_label": "Déconnecter {user} sur {host}",
  "ShipSettingsView_disconnect_companion_title": "Déconnecter le Companion ?",
  "ShipSettingsView_disconnect_companion_text": "Ce Companion devra être reconnecté manuellement. Les autorisations de l’utilisateur sur le bateau et les autres appareils resteront inchangés.",
  "ShipSettingsView_disconnect_companion_error": "Impossible de déconnecter ce Companion. Veuillez réessayer.",

  "ShipSettingsView_units": "Paramètres des unités",

  "ShipSettingsView_comment_": "*Choisir ou entrer*",
  "ShipSettingsView_seaState_": "*Choisir ou entrer*",

  "ShipSettingsView_comment_anchor_down": "Ancre mouillée",
  "ShipSettingsView_comment_anchor_up": "Ancre levée",
  "ShipSettingsView_comment_engine_started": "Moteur démarré",
  "ShipSettingsView_comment_engine_stopped": "Moteur arrêté",
  "ShipSettingsView_comment_sails_set": "Voiles hissée",
  "ShipSettingsView_comment_sails_dropped": "Voiles affalées",

  "ShipSettingsView_add_seaState": "Ajouter état de la mer",
  "ShipSettingsView_add_comment": "Ajouter un commentaire",

  "ShipSettingsView_seaState_waves": "Vagues",
  "ShipSettingsView_seaState_swell": "Houle",
  "ShipSettingsView_seaState_cross_sea": "Mer croisée",
  "ShipSettingsView_seaState_calm": "Mer calme",
  "ShipSettingsView_seaState_rough": "Mer agitée",

  "ShipSettingsView_currency": "Devise",
  "ShipSettingsView_distance": "Distance",
  "ShipSettingsView_length": "Longueur",
  "ShipSettingsView_power": "Puissance",
  "ShipSettingsView_pressure": "Pression",
  "ShipSettingsView_speed": "Vitesse",
  "ShipSettingsView_surface": "Surface",
  "ShipSettingsView_temperature": "Température",
  "ShipSettingsView_volume": "Volume",
  "ShipSettingsView_weight": "Poids",
  "ShipSettingsView_wind": "Vent",
  "ShipSettingsView_current": "Courant",
  "ShipSettingsView_unit_currency": "Devise",

  "ShipSettingsView_unit_bar": "bar",
  "ShipSettingsView_unit_celsius": "°C",
  "ShipSettingsView_unit_cm": "cm",
  "ShipSettingsView_unit_fahrenheit": "°F",
  "ShipSettingsView_unit_foot": "pied",
  "ShipSettingsView_unit_gal": "gal",
  "ShipSettingsView_unit_inch": "pouce",
  "ShipSettingsView_unit_kg": "kg",
  "ShipSettingsView_unit_km": "km",
  "ShipSettingsView_unit_kmh": "km/h",
  "ShipSettingsView_unit_kn": "kn",
  "ShipSettingsView_unit_kw": "kw",
  "ShipSettingsView_unit_kwh": "kwh",
  "ShipSettingsView_unit_hp": "hp",
  "ShipSettingsView_unit_l": "l",
  "ShipSettingsView_unit_m3": "m³",
  "ShipSettingsView_unit_cuft": "cuft",
  "ShipSettingsView_unit_mps": "m/s",
  "ShipSettingsView_unit_m": "m",
  "ShipSettingsView_unit_m2": "m²",
  "ShipSettingsView_unit_miles": "miles",
  "ShipSettingsView_unit_mph": "mph",
  "ShipSettingsView_unit_nm": "nm",
  "ShipSettingsView_unit_lb": "lb",
  "ShipSettingsView_unit_ft": "ft",
  "ShipSettingsView_unit_in": "in",
  "ShipSettingsView_unit_sqft": "sqft",
  "ShipSettingsView_unit_psi": "psi",
  "ShipSettingsView_unit_sqyd": "sqyd",
  "ShipSettingsView_unit_tons": "to",
  "ShipSettingsView_unit_yard": "yard",
  "ShipSettingsView_unit_hpa": "hPa",

  "ShipSettingsView_unit_undefined": "*Choisir ou entrer*",
  "ShipSettingsView_other": "Entrer autre",

  "ShipSettingsView_unit_eur": "€",
  "ShipSettingsView_unit_usd": "$",
  "ShipSettingsView_unit_gbp": "£",
  "ShipSettingsView_unit_aud": "AU$",
  "ShipSettingsView_unit_nzd": "NZ$",
  "ShipSettingsView_unit_chf": "CHF",
  "ShipSettingsView_unit_sek": "SEK",
  "ShipSettingsView_unit_nok": "NOK",
  "ShipSettingsView_unit_dkk": "DKK",
  "ShipSettingsView_unit_jpy": "¥",

  "ShipSettingsView_user_crew_role": "Rôle d'équipage",
  "ShipSettingsView_ship_user_crew_role_crew": "Équipage",
  "ShipSettingsView_ship_user_crew_role_none": "Aucun",
  "ShipSettingsView_ship_user_crew_role_owner": "Titulaire du compte",
  "ShipSettingsView_ship_user_crew_role_skipper": "Capitaine",
  "ShipSettingsView_user_email": "E-mail",
  "ShipSettingsView_language": "Langue",
  "ShipSettingsView_lang_en": "English",
  "ShipSettingsView_lang_de": "Deutsch",
  "ShipSettingsView_lang_fr": "Français",
  "ShipSettingsView_user_name": "Nom",
  "ShipSettingsView_user_shortname": "Nom court",
  "ShipSettingsView_user_account": "Compte",
  "ShipSettingsView_user_active": "Activer",
  "ShipSettingsView_user_inactive": "Désactiver",
  "ShipSettingsView_user_invite": "Inviter",
  "ShipSettingsView_user_invite_title": "Inviter un utilisateur du navire à LOGBOOK",
  "ShipSettingsView_user_reactivate": "Réactiver",
  "ShipSettingsView_remove_user": "Supprimer",
  "ShipSettingsView_user_deactivate_confirm_title": "Désactiver l'utilisateur",
  "ShipSettingsView_user_deactivate_confirm_message": "Voulez-vous vraiment désactiver l'accès de cet utilisateur au navire ? S'il n'a plus d'autre accès à un navire sur ce compte, son compte sera également désactivé.",
  "ShipSettingsView_user_deactivate_confirm_accept": "Désactiver",
  "ShipSettingsView_user_deactivate_confirm_cancel": "Annuler",
  "ShipSettingsView_user_remove_confirm_title": "Supprimer l'utilisateur",
  "ShipSettingsView_user_remove_confirm_message": "Voulez-vous vraiment supprimer cet utilisateur du navire ? Cette action est irréversible.",
  "ShipSettingsView_user_remove_confirm_accept": "Supprimer",
  "ShipSettingsView_user_remove_confirm_cancel": "Annuler",

  "ShipSettingsView_ship_user_level": "Autorisations",
  "ShipSettingsView_ship_user_level_primary": "Primary",
  "ShipSettingsView_ship_user_level_editAll": "Voir et modifier tout",
  "ShipSettingsView_ship_user_level_editCurrent": "Voir et modifier le voyage actuel",
  "ShipSettingsView_ship_user_level_viewAll": "Voir tout",
  "ShipSettingsView_ship_user_level_viewCurrent": "Voir le voyage actuel",
  "ShipSettingsView_ship_user_level_none": "Aucun",

  "ShipSettingsView_user_status": "Statut",
  "ShipSettingsView_user_status_active": "Actif",
  "ShipSettingsView_user_status_invited": "Invité",
  "ShipSettingsView_user_status_undefined": " ",

  "ShipSettingsView_user_add_user": "Ajouter une personne",
  "ShipSettingsView_add_user_with_permissions": "Ajouter une personne avec des autorisations pour LOGBOOK",
  "ShipSettingsView_add_user_without_permissions": "Ajouter une personne sans autorisations",
  "ShipSettingsView_users_with_level": "Utilisateurs du navire avec des autorisations pour LOGBOOK",
  "ShipSettingsView_users_without_level": "Personnes sans autorisations",

  "ShipContentView": "",
  "ShipContentView_back": "Retour",

  "ShipDataView": "",
  "ShipDataView_blank": "  ",
  "ShipDataView_": "*Choisir*",
  "ShipDataView_add": "Ajouter",
  "ShipDataView_ship_data": "Données du navire",
  "ShipDataView_file_field_drag_drop": "Insérez ici les photos de votre navire.",

  "ShipDataView_general": "Données générales du navire",
  "ShipDataView_choose": "*Choisir ou entrer* ",
  "ShipDataView_other": "Entrer autre",

  "ShipDataView_tab_general": "Général",
  "ShipDataView_tab_details": "Détails",
  "ShipDataView_tab_technic": "Technique",
  "ShipDataView_tab_sailing": "Navigation à voile",
  "ShipDataView_tab_equipment": "Équipement",
  "ShipDataView_tab_ship_user": "Toutes les personnes",
  "ShipDataView_tab_units": "Unités",

  "ShipDataView_callsign": "Indicatif",
  "ShipDataView_imo": "IMO",
  "ShipDataView_mmsi": "MMSI",
  "ShipDataView_name": "Nom",

  "ShipDataView_reg_number": "Numéro d'immatriculation",
  "ShipDataView_hin": "HIN",
  "ShipDataView_flag": "Pavillon",
  "ShipDataView_home_port": "Port d'attache",
  "ShipDataView_yacht_club": "Club nautique",
  "ShipDataView_yacht_club_address": "Adresse",

  "ShipDataView_model_name": "Nom du modèle",
  "ShipDataView_year": "Année",
  "ShipDataView_yachtbuilder": "Constructeur",
  "ShipDataView_designer": "Architecte",
  "ShipDataView_construction": "Construction générale",
  "ShipDataView_build_number": "Numéro de construction",
  "ShipDataView_cel": "Catégorie CEL",
  "ShipDataView_cel_persons": "pour personnes",

  "ShipDataView_ship_foto": "Photo du navire",

  "ShipDataView_inside": "Espace de vie",
  "ShipDataView_berth_no": "Nb total de couchettes",
  "ShipDataView_berth_single_no": "Nb de couchettes simples",
  "ShipDataView_berth_double_no": "Nb de couchettes doubles",
  "ShipDataView_berth_extra_no": "Nb de couchettes supplémentaires",
  "ShipDataView_cabins_no": "Nb de cabines",
  "ShipDataView_bath_no": "Nb de salles de bain",
  "ShipDataView_saloon": "Salon",
  "ShipDataView_pantry": "Cuisine",
  "ShipDataView_cabins": "Cabines",
  "ShipDataView_cockpit": "Cockpit",

  "ShipDataView_owner": "Propriétaire",
  "ShipDataView_owner_name": "Nom",
  "ShipDataView_owner_address": "Adresse",
  "ShipDataView_owner_phone": "Téléphone",
  "ShipDataView_owner_email": "E-mail",

  "ShipDataView_shape": "Forme",
  "ShipDataView_monohull": "Monocoque",
  "ShipDataView_catamaran": "Catamaran",
  "ShipDataView_trimaran": "Trimaran",

  "ShipDataView_sailing-sloop": "Voilier sloop",
  "ShipDataView_sailing-ketch": "Voilier ketch",
  "ShipDataView_sailing-classic": "Voilier classique",
  "ShipDataView_sailing-cat": "Voilier catamaran",
  "ShipDataView_sailing-tri": "Voilier trimaran",
  "ShipDataView_sailing-longkeeler": "Voilier longue quille",
  "ShipDataView_motor-boat": "Bateau à moteur",
  "ShipDataView_motor-cat": "Catamaran à moteur",
  "ShipDataView_motor-tri": "Trimaran à moteur",
  "ShipDataView_motor-yacht": "Yacht à moteur",
  "ShipDataView_motor-superyacht": "Superyacht à moteur",
  "ShipDataView_special_features": "Caractéristiques spéciales",

  "ShipDataView_vessel_type": "Type de navire",

  "ShipDataView_dimensions": "Dimensions",
  "ShipDataView_height": "A : Hauteur",
  "ShipDataView_draft": "B : Tirant d'eau",
  "ShipDataView_length_waterline": "C : Longueur à la flottaison",
  "ShipDataView_length_hull": "D : Longueur de coque",
  "ShipDataView_length": "E : Longueur hors tout",
  "ShipDataView_beam": "Largeur",
  "ShipDataView_hull_material": "Matériau de la coque",
  "ShipDataView_hull_color": "Couleur de la coque",
  "ShipDataView_masts_no": "Nombre de mâts",
  "ShipDataView_rig": "Forme du gréement",
  "ShipDataView_sail_area_total": "Surface de voilure",
  "ShipDataView_comment": "Commentaire",

  "ShipDataView_displacement": "Déplacement",
  "ShipDataView_keel_weight": "Poids de la quille",
  "ShipDataView_keel_material": "Matériau de la quille",
  "ShipDataView_ballast_percentage": "Pourcentage de ballast",
  "ShipDataView_keel_shape": "Forme de la quille",
  "ShipDataView_keel_weight_percent": "Poids de la quille %",

  "ShipDataView_mast_rig": "Mât, gréement et équipement de pont",
  "ShipDataView_rig_elements": "Éléments du gréement",
  "ShipDataView_rig_element": "Élément du gréement",
  "ShipDataView_rig_mast": "Mât",
  "ShipDataView_rig_main_mast": "Grand mât",
  "ShipDataView_rig_stay": "Étai de flèche",
  "ShipDataView_rig_mizzen_mast": "Mât d'artimon",
  "ShipDataView_rig_forestay": "Étai avant",
  "ShipDataView_rig_jib_stay": "Étai de foc",
  "ShipDataView_rig_backstay": "Pataras",
  "ShipDataView_rig_runner": "Pataras mobile",
  "ShipDataView_rig_baby_stay": "Baby stay",
  "ShipDataView_rig_kicker": "Hale-bas",
  "ShipDataView_rig_vang": "Vang",
  "ShipDataView_rig_winch": "Winch",
  "ShipDataView_rig_": "*Choisir ou entrer* ",
  "ShipDataView_rig_null": "*Choisir ou entrer* ",

  "ShipDataView_unit_m": "m",
  "ShipDataView_unit_cm": "cm",
  "ShipDataView_unit_inch": "pouce",
  "ShipDataView_unit_foot": "pied",
  "ShipDataView_unit_yard": "yard",
  "ShipDataView_unit_nm": "nm",

  "ShipDataView_unit_m2": "m²",
  "ShipDataView_unit_square_foot": "sqft",
  "ShipDataView_unit_square_yard": "sqyd",

  "ShipDataView_unit_pound": "lb",
  "ShipDataView_unit_kg": "kg",
  "ShipDataView_unit_tons": "to",

  "ShipDataView_unit_knots": "kn",
  "ShipDataView_unit_m_per_second": "m/s",
  "ShipDataView_unit_km_per_hour": "km/h",
  "ShipDataView_unit_kWh": "kWh",
  "ShipDataView_unit_kw": "kW",
  "ShipDataView_unit_hp": "hp",

  "ShipDataView_unit_l": "l",
  "ShipDataView_unit_gal": "gal",
  "ShipDataView_unit_liter": "l",
  "ShipDataView_unit_gallon": "gal",
  "ShipDataView_unit_celsius": "°C",
  "ShipDataView_unit_fahrenheit": "°F",

  "ShipDataView_other_equipment": "Autre équipement",
  "ShipDataView_other_equipment_text": "Entrez ici tout autre équipement du navire qui n'a pas pu être saisi dans les autres zones, comme les informations sur l'annexe, etc.",

  "ShipDataView_add_engine": "Ajouter un moteur",
  "ShipDataView_add_generator": "Ajouter un générateur",
  "ShipDataView_add_sail": "Ajouter une voile",
  "ShipDataView_add_insurance": "Ajouter une assurance",
  "ShipDataView_add_anchor": "Ajouter une ancre",
  "ShipDataView_add_tank": "Ajouter un réservoir",
  "ShipDataView_add_steeringsystem": "Ajouter un système de direction",
  "ShipDataView_add_other_equipment": "Ajouter un autre équipement",
  "ShipDataView_add_rig": "Ajouter un équipement de gréement",
  "ShipDataView_nautical_add_device": "Ajouter un appareil",
  "ShipDataView_safety_add_device": "Ajouter un équipement",
  "ShipDataView_electric_add_device": "Ajouter un appareil",

  "ShipDataView_insurance": "Assurance",
  "ShipDataView_insurances": "Assurances",
  "ShipDataView_insurance_": "*Choisir ou entrer* ",
  "ShipDataView_insurance_null": "*Choisir ou entrer* ",
  "ShipDataView_insurance_undefined": "*Choisir ou entrer* ",
  "ShipDataView_insurance_company": "Compagnie d'assurance",
  "ShipDataView_insurance_number": "Numéro d'assurance",
  "ShipDataView_insurance_type": "Type d'assurance",
  "ShipDataView_insurance_hull": "Coque",
  "ShipDataView_insurance_liability": "Responsabilité civile",
  "ShipDataView_insurance_accident": "Accident",

  "ShipDataView_engines": "Moteurs",
  "ShipDataView_engine": "Moteur",
  "ShipDataView_engine#": "N°",
  "ShipDataView_engine_nmea_number": "NMEA",
  "ShipDataView_engine_short_name": "Nom (max. 10 car.)",
  "ShipDataView_engine_": "*Choisir ou entrer* ",
  "ShipDataView_engine_undefined": "*Choisir ou entrer* ",
  "ShipDataView_engine_null": "*Choisir ou entrer* ",

  "ShipDataView_engine_outboard": "Hors-bord",
  "ShipDataView_engine_saildrive": "Saildrive",
  "ShipDataView_engine_shaftdrive": "Arbre d'hélice",
  "ShipDataView_engine_z_drive": "Z-drive",
  "ShipDataView_engine_pod_drive": "Pod drive",
  "ShipDataView_engine_jet_drive": "Jet drive",

  "ShipDataView_generator_": "*Choisir ou entrer* ",
  "ShipDataView_generator_undefined": "*Choisir ou entrer* ",
  "ShipDataView_generator_null": "*Choisir ou entrer* ",

  "ShipDataView_generator": "Générateur",
  "ShipDataView_generators": "Générateurs",
  "ShipDataView_generator_power_generator": "Générateur électrique",
  "ShipDataView_generator_warm_water": "Eau chaude",
  "ShipDataView_generator_watermaker": "Dessalinisateur",
  "ShipDataView_generator_heating": "Chauffage",
  "ShipDataView_generator_air_conditioning": "Climatisation",

  "ShipDataView_fuel_": "*Choisir ou entrer* ",
  "ShipDataView_fuel_null": "*Choisir ou entrer* ",
  "ShipDataView_fuel_undefined": "*Choisir ou entrer* ",
  "ShipDataView_fuel_type": "Carburant",
  "ShipDataView_fuel_diesel": "Diesel",
  "ShipDataView_fuel_petrol": "Essence",
  "ShipDataView_fuel_gas": "Gaz",
  "ShipDataView_fuel_electricity": "Électricité",

  "ShipDataView_drive_type_engine_null": "*Choisir ou entrer* ",
  "ShipDataView_number": "Numéro",
  "ShipDataView_manufacturer": "Fabricant",
  "ShipDataView_model": "Modèle",
  "ShipDataView_serial_number": "Numéro de série",
  "ShipDataView_power": "Puissance",
  "ShipDataView_drive_type": "Type de propulsion",
  "ShipDataView_propeller_type": "Type d'hélice",

  "ShipDataView_steering_null": "*Choisir ou entrer* ",
  "ShipDataView_steering_systems": "Systèmes de direction",
  "ShipDataView_steering_system_main": "Système de direction principal",
  "ShipDataView_steering_": "*Choisir ou entrer* ",
  "ShipDataView_steering_type": "Type de direction",
  "ShipDataView_rudder_no": "Nombre de safrans",
  "ShipDataView_rudder_shape": "Forme",
  "ShipDataView_rudder_drive": "Commande de safran",
  "ShipDataView_steering_bow_thruster": "Propulseur d'étrave",
  "ShipDataView_steering_stern_thruster": "Propulseur de poupe",
  "ShipDataView_steering_self_steering": "Régulateur d'allure",
  "ShipDataView_steering_windvane": "Girouette",
  "ShipDataView_steering_trimtab": "Trim-tab",
  "ShipDataView_steering_autopilot": "Pilote automatique",

  "ShipDataView_tanks": "Réservoirs",
  "ShipDataView_tanks_unit": "réservoirs : ∑ ",
  "ShipDataView_tank": "Type de réservoir",
  "ShipDataView_tank_": "*Choisir ou entrer* ",
  "ShipDataView_tank_undefined": "*Choisir ou entrer* ",
  "ShipDataView_tank_null": "*Choisir ou entrer* ",

  "ShipDataView_tank_fuel": "Carburant",
  "ShipDataView_tank_water": "Eau douce",
  "ShipDataView_tank_gray": "Eaux grises",
  "ShipDataView_tank_waste": "Eaux usées",
  "ShipDataView_tank_gas": "Gaz",
  "ShipDataView_tank_fuel_daytank": "Réservoir journalier de carburant",

  "ShipDataView_tank_size": "Capacité",
  "ShipDataView_tank_comment": "Commentaire",

  "ShipDataView_no": "nombre",
  "ShipDataView_tank_fuel_no": "Carburant : nbre | ∑ capacité",
  "ShipDataView_tank_water_no": "Eau douce : nbre | ∑ capacité",
  "ShipDataView_tank_gray_no": "Eaux grises : nbre | ∑ capacité",
  "ShipDataView_tank_waste_no": "Eaux usées : nbre | ∑ capacité",
  "ShipDataView_tank_gas_no": "Gaz : nbre | ∑ capacité",

  "ShipDataView_anchors": "Ancres",
  "ShipDataView_anchor_type": "Type d'ancre",
  "ShipDataView_anchor_": "*Choisir ou entrer* ",
  "ShipDataView_anchor_null": "*Choisir ou entrer* ",

  "ShipDataView_anchor_weight": "Poids",
  "ShipDataView_anchor_location": "Lieu d'installation",

  "ShipDataView_bow": "proue",
  "ShipDataView_stern": "poupe",
  "ShipDataView_variable": "variable",

  "ShipDataView_anchor_chain": "Longueur et type de chaîne",
  "ShipDataView_anchor_chain_lead": "Guidage de chaîne",
  "ShipDataView_anchor_windlass": "Guindeau",
  "ShipDataView_anchor_windless_drive": "Propulsion",
  "ShipDataView_anchor_windless_manfacturer": "Fabricant",

  "ShipDataView_anchor_spade": "Ancre Spade",
  "ShipDataView_anchor_fishermans": "Ancre de marine",
  "ShipDataView_anchor_plough": "Ancre CQR/charrue",
  "ShipDataView_anchor_danforth": "Ancre Danforth",
  "ShipDataView_anchor_rollerbar": "Ancre à barre rotative",

  "ShipDataView_manual": "manuel",
  "ShipDataView_electric": "électrique",

  "ShipDataView_watermaker": "Dessalinisateur",
  "ShipDataView_batteries": "Batteries",
  "ShipDataView_batterie": "Batterie",
  "ShipDataView_capacity": "Capacité",
  "ShipDataView_electrics": "Électricité",
  "ShipDataView_date_purchase": "Date d'achat",
  "ShipDataView_charger": "Chargeur",
  "ShipDataView_inverter": "Onduleur",
  "ShipDataView_hot_water_boiler": "Chauffe-eau",
  "ShipDataView_size": "Taille",
  "ShipDataView_size_height": "Taille/hauteur",

  "ShipDataView_place_installation": "Lieu d'installation",
  "ShipDataView_date_installation": "Date d'installation",

  "ShipDataView_devices": "Appareils",
  "ShipDataView_device": "Appareil",

  "ShipDataView_sails": "Voiles",
  "ShipDataView_sail": "Voile",
  "ShipDataView_sail_": "*Choisir ou entrer* ",
  "ShipDataView_sail_null": "*Choisir ou entrer* ",

  "ShipDataView_sail_size": "Taille",
  "ShipDataView_sail_type": "Établie sur",
  "ShipDataView_sail_reefs_no": "Nombre de ris",

  "ShipDataView_sail_mast": "Mât",
  "ShipDataView_sail_forestay": "Étai avant",
  "ShipDataView_sail_mizzen": "Artimon",
  "ShipDataView_sail_mainsail": "Grand-voile",
  "ShipDataView_sail_spinnaker": "Spinnaker",
  "ShipDataView_sail_genoa": "Génois",
  "ShipDataView_sail_jib": "Foc",
  "ShipDataView_sail_working_jib": "Foc de travail",
  "ShipDataView_sail_strom_jib": "Tourmenin",
  "ShipDataView_sail_mizzen_staysail": "Voile d'étai d'artimon",
  "ShipDataView_sail_code0": "Code 0",
  "ShipDataView_sail_gennaker": "Gennaker",
  "ShipDataView_sail_try": "Voile de cape",
  "ShipDataView_sail_storm_jib": "Tourmenin",
  "ShipDataView_sail_parasailor": "Parasailor",
  "ShipDataView_sail_0": "Aucun",
  "ShipDataView_sail_1": "1",
  "ShipDataView_sail_2": "2",
  "ShipDataView_sail_3": "3",
  "ShipDataView_sail_reef_1": "Ris 1",
  "ShipDataView_sail_reef_2": "Ris 2",
  "ShipDataView_sail_reef_3": "Ris 3",
  "ShipDataView_sail_reef": "{sail} - {reef}",

  "ShipDataView_device_": "*Choisir ou entrer* ",
  "ShipDataView_device_undefined": "*Choisir ou entrer* ",
  "ShipDataView_device_nautical_": "*Choisir ou entrer* ",
  "ShipDataView_device_electric_": "*Choisir ou entrer* ",
  "ShipDataView_device_safety_": "*Choisir ou entrer* ",
  "ShipDataView_device_nautical_null": "*Choisir ou entrer* ",
  "ShipDataView_device_electric_null": "*Choisir ou entrer* ",
  "ShipDataView_device_safety_null": "*Choisir ou entrer* ",

  "ShipDataView_nautical_equipment": "Équipement nautique",
  "ShipDataView_safety_equipment": "Équipement de sécurité",
  "ShipDataView_electric_equipment": "Équipement électrique",

  "ShipDataView_device_nautical_analogue_compass": "Compas analogique",
  "ShipDataView_device_nautical_gyro_compass": "Compas gyroscopique",
  "ShipDataView_device_nautical_fluxgate_compass": "Compas fluxgate",
  "ShipDataView_device_nautical_satellite_compass": "Compas satellite",
  "ShipDataView_device_nautical_chart_plotter": "Traceur de cartes",
  "ShipDataView_device_nautical_gps": "GPS",
  "ShipDataView_device_nautical_ais": "Transpondeur AIS",
  "ShipDataView_device_nautical_radio": "Radio",
  "ShipDataView_device_nautical_antenna": "Antenne",
  "ShipDataView_device_nautical_radar": "Radar",
  "ShipDataView_device_nautical_wind_gauge": "Anémomètre",
  "ShipDataView_device_nautical_autopilot": "Pilote automatique",
  "ShipDataView_device_nautical_display_instruments": "Instruments d'affichage",
  "ShipDataView_device_nautical_fuel_gauge": "Jauge de carburant",
  "ShipDataView_device_nautical_battery_controller": "Contrôleur de batterie",
  "ShipDataView_device_nautical_hour_meter": "Compte-heures",
  "ShipDataView_device_nautical_tachometer": "Tachymètre",
  "ShipDataView_device_nautical_logger": "Loch",
  "ShipDataView_device_nautical_sounder": "Sondeur",
  "ShipDataView_device_nautical_air_temperature": "Température de l'air",
  "ShipDataView_device_nautical_barometer": "Baromètre",
  "ShipDataView_device_nautical_humidity": "Humidité",
  "ShipDataView_device_nautical_weather_receiver": "Récepteur météo",
  "ShipDataView_device_nautical_nmea_gateway": "Passerelle NMEA",
  "ShipDataView_device_nautical_nmea_motor_adapter": "Adaptateur moteur NMEA",

  "ShipDataView_device_electric_battery": "Batterie",
  "ShipDataView_device_electric_inverter": "Onduleur",
  "ShipDataView_device_electric_charger": "Chargeur",
  "ShipDataView_device_electric_solar_panel": "Panneau solaire",
  "ShipDataView_device_electric_wind_generator": "Éolienne",
  "ShipDataView_device_electric_watermaker": "Dessalinisateur",

  "ShipDataView_device_safety_fire_extinguisher": "Extincteur",
  "ShipDataView_device_safety_liferaft": "Radeau de sauvetage",
  "ShipDataView_device_safety_lifejacket": "Gilet de sauvetage",
  "ShipDataView_device_safety_lifebelt": "Bouée de sauvetage",
  "ShipDataView_device_safety_lifeline": "Ligne de vie",
  "ShipDataView_device_safety_spare_propeller": "Hélice de rechange",
  "ShipDataView_device_safety_emergency_tiller": "Barre de secours",
  "ShipDataView_device_safety_bilge_pump_manual": "Pompe de cale manuelle",
  "ShipDataView_device_safety_bilge_pump_electric": "Pompe de cale électrique",
  "ShipDataView_device_safety_shroud_cutter": "Coupe-haubans",
  "ShipDataView_device_safety_radar_reflector": "Réflecteur radar",
  "ShipDataView_device_safety_first_aid": "Premiers secours",
  "ShipDataView_device_safety_fire_blanket": "Couverture anti-feu",
  "ShipDataView_device_safety_dinghy": "Annexe",
  "ShipDataView_device_safety_dinghy_motor": "Moteur pour annexe",
  "ShipDataView_device_safety_handheld_radio": "Radio portable",
  "ShipDataView_device_safety_epirb": "Balise de détresse EPIRB",
  "ShipDataView_all_users": "Toutes les personnes pour l'équipage, etc.",

  "ShipEditView": "",
  "ShipEditView_name": "Nom du navire",
  "ShipEditView_name_min": "Nom du navire (min 3 caractères)",
  "ShipEditView_title_edit": "Données du navire pour {ship}",
  "ShipEditView_title_new": "Créer un nouveau navire",
  "ShipEditView_type": "Type de navire",
  "ShipEditView_type_motor": "Navire à moteur",
  "ShipEditView_type_sailing": "Voilier",
  "ShipEditView_engines": "Nombre de moteurs",
  "ShipEditView_generators": "Nombre de générateurs",
  "ShipEditView_create": "Créer un navire",
  "ShipEditView_cancel": "Annuler",
  "ShipEditView_choose": "Choisir",
  "ShipEditView_print": "Imprimer les données du navire",

  "ShipSelectView": "",
  "ShipSelectView_companion": "C",
  "ShipSelectView_view_logbook": "Voir",
  "ShipSelectView_selecting": "Sélection en cours...",
  "ShipSelectView_options": "Options",
  "ShipSelectView_nearby": "Trouvé sur votre réseau",
  "ShipSelectView_nearby_hint": "Ce navire est annoncé sur votre réseau actuel.",
  "ShipSelectView_unavailable_no_permission": "Vous n'avez pas l'autorisation d'ouvrir ce navire comme LOGBOOK Primary.",
  "ShipSelectView_unavailable_import_in_progress": "Un import est encore en cours pour ce navire.",

  "ShipSyncStatusView": "",
  "ShipSyncStatusView_close": "Fermer",
  "ShipSyncStatusView_retry": "Réessayer",
  "ShipSyncStatusView_title": "Synchronisation avec LOGBOOK Cloud",

  "ShipUserSelect": "",
  "ShipUserSelect_add_user": "Ajouter une personne",
  "ShipUserSelect_dialog_add_new_user": "Ajouter une nouvelle personne",
  "ShipUserSelect_dialog_add_user": "Ajouter une nouvelle personne",
  "ShipUserSelect_dialog_add_user_name": "Nom",
  "ShipUserSelect_dialog_add_user_shortname": "Nom court",
  "ShipUserSelect_dialog_cancel": "Annuler",
  "ShipUserSelect_loading": "Chargement…",
  "ShipUserSelect_no_users": "Aucune personne disponible",
  "ShipUserSelect_select_additional_user": "+",
  "ShipUserSelect_select_user": "Sélectionner",

  "ShipView": "",

  "ShipView_add_cruise": "Voyage",
  "ShipView_add_ship": "Navire",
  "ShipView_empty_select": "Sélectionnez d'abord un navire.",

  "ShipView_import_trips_title": "Importer les anciens trajets depuis LogbookSuite",
  "ShipView_import_trips_choose": "Choisir un fichier",
  "ShipView_import_trips_cancel": "Annuler",

  "ShipView_menu_action_title": "Nouveau",
  "ShipView_menu_NMEA": "NMEA",
  "ShipView_menu_now": "Focus",
  "ShipView_menu_search": "Rechercher",
  "ShipView_nmea_recording_disconnected": "NMEA déconnecté",
  "ShipView_nmea_recording_error": "Erreur d'enregistrement NMEA :",
  "ShipView_nmea_recording_error_disconnected": "Erreur d'enregistrement NMEA : NMEA non connecté",
  "ShipView_overlay_dismiss": "OK",
  "ShipView_overlay_missing_cruise": "Impossible de démarrer l'enregistrement sans un trajet et un voyage actifs. Créez d'abord un voyage.",
  "ShipView_overlay_missing_trip": "Impossible de démarrer l'enregistrement sans un trajet actif. Créez d'abord un trajet.",
  "ShipView_ship_data": "Données du navire",
  "ShipView_ship_settings": "Paramètres",
  "ShipView_sync_initialSyncInProgress": "Synchronisation initiale en cours",
  "ShipView_sync_settings": "Paramètres",
  "ShipView_sync_uninitialized": "Préparation de la synchronisation",

  "ShipView_resync_cancel": "Annuler",
  "ShipView_resync_confirm_cancel": "Retour",
  "ShipView_resync_confirm_execute": "Confirmer",
  "ShipView_resync_title": "Réinitialiser la connexion déconnectée",
  "ShipView_resync_reset_local": "Utiliser les données locales",
  "ShipView_resync_reset_cloud": "Utiliser les données du Cloud",
  "ShipView_resync_last_sync": "Dernière synchronisation de cet appareil",
  "ShipView_resync_cloud_updated": "Dernière mise à jour du LOGBOOK Cloud",
  "ShipView_resync_status_failed": "Le LOGBOOK Cloud n'a pas pu être contacté, l'état de la connexion est donc inconnu. Vérifiez votre connexion Internet et réessayez.",
  "ShipView_resync_permission_required": "Votre compte cloud ne dispose plus de l'autorisation Primary pour ce navire. La synchronisation et la récupération nécessitent cette autorisation. Demandez au propriétaire du navire de la rétablir, puis réessayez la synchronisation. Gardez le navire ouvert pour préserver les modifications locales non synchronisées ; fermer la connexion cloud ne rétablit pas l'autorisation.",
  "ShipView_resync_claimed_here": "Le LOGBOOK Cloud reconnaît toujours cet appareil comme Primary. Une réinitialisation est impossible tant que cette connexion est active. Réessayez d'abord la synchronisation. Si une réinitialisation reste nécessaire, fermez le navire dans le LOGBOOK Cloud, puis rouvrez cette fenêtre et choisissez les données à conserver. Gardez le navire ouvert dans cette application jusqu'à la fin de la récupération pour préserver les modifications locales non synchronisées.",
  "ShipView_resync_reset_failed": "La connexion n'a pas pu être rétablie. Veuillez réessayer.",
  "ShipView_resync_reset_claimed": "Le cloud a refusé la récupération. Votre autorisation ou la connexion du navire a peut-être changé. Revenez en arrière pour vérifier l'état actuel avant de réessayer.",
  "ShipView_read_more": "En savoir plus",

  "StatsView": "",
  "StatsView_days_run": "Distance du jour",
  "StatsView_distance_total": "Distance totale",
  "StatsView_distance_under_engine": "Distance au moteur",
  "StatsView_distance_under_engine_name": "{name}",
  "StatsView_distance_under_sails": "Distance à la voile",
  "StatsView_duration_under_engine": "Temps au moteur",
  "StatsView_duration_under_engine_name": "{name}",
  "StatsView_duration_under_sails": "Temps à la voile",
  "StatsView_speed": "Vitesse moyenne",
  "StatsView_time_total": "Temps total",
  "StatsView_time_total_paused_cruising": "Temps : Total | Pause | Navigation",
  "StatsView_update": "Recalculer",

  "TrackView": "",
  "TrackView_no_track": "Aucune trace disponible",

  "TripEditView": "",
  "TripEditView_cancel": "Annuler",
  "TripEditView_current_time": "Heure actuelle",
  "TripEditView_dialog_title": "Créer un trajet",
  "TripEditView_start": "Commencer le trajet",
  "TripEditView_timezone": "Fuseau horaire",
  "TripEditView_title": "Nom du trajet",

  "TripView": "",
  "TripView_tab_crew": "Équipage",
  "TripView_tab_stats": "Statistiques",
  "TripView_tab_track": "Trace",
  "TripView_tab_trip": "Trajet",
  "TripView_tab_weather": "Météo",
  "TripView_tab_print": "Imprimer",
  "TripView_untitled_trip": "Trajet sans titre",
  "TripView_print_all": "Imprimer tous les trajets de ce voyage",
  "TripView_print_trip": "Imprimer ce trajet",

  "UserAdviceAlertView": "",
  "UserAdviceAlertView_alert_acknowledged": "Acquittée",
  "UserAdviceAlertView_alert_alarm": "Alarme",
  "UserAdviceAlertView_alert_anchorDrift": "Dérive du mouillage",
  "UserAdviceAlertView_alert_anchorDrift_short": "Dérive",
  "UserAdviceAlertView_alert_default": "Statut inconnu",
  "UserAdviceAlertView_alert_depth": "Profondeur",
  "UserAdviceAlertView_alert_depth_short": "Profondeur",
  "UserAdviceAlertView_alert_ignored": "Ignorée",
  "UserAdviceAlertView_alert_lostPosition": "Position perdue",
  "UserAdviceAlertView_alert_lostPosition_short": "Position",
  "UserAdviceAlertView_alert_message": "Message",
  "UserAdviceAlertView_alert_message_short": "Message",
  "UserAdviceAlertView_alert_ok": "OK",
  "UserAdviceAlertView_alert_pressure": "Pression",
  "UserAdviceAlertView_alert_pressure_short": "Pression",
  "UserAdviceAlertView_alert_resolved": "Résolue",
  "UserAdviceAlertView_alert_test": "Test",
  "UserAdviceAlertView_alert_test_short": "Test",
  "UserAdviceAlertView_alert_warning": "Avertissement",
  "UserAdviceAlertView_alert_wind": "Vent",
  "UserAdviceAlertView_alert_wind_short": "Vent",
  "UserAdviceAlertView_alert_lights": "Signaux visuels",
  "UserAdviceAlertView_alert_lights_short": "Feux",
  "UserAdviceAlertView_alert_manOverboard": "Homme à la mer",
  "UserAdviceAlertView_alert_manOverboard_short": "MOB",
  "UserAdviceAlertView_state_snoozed": "En veille",
  "UserAdviceAlertView_state_acknowledged": "Acquittée",
  "UserAdviceAlertView_state_audible": "Sonore",
  "UserAdviceAlertView_close": "Fermer",
  "UserAdviceAlertView_record": "J’ai réglé {lighting}",
  "UserAdviceAlertView_cancel": "Annuler",
  "UserAdviceAlertView_settings": "Réglages",
  "UserAdviceAlertView_submit": "Définir le statut : {state}",
  "UserAdviceAlertView_submit_none": "Choisissez une action",
  "UserAdviceAlertView_state_snooze": "Reporté",
  "UserAdviceAlertView_state_acknowledge": "Acquitté",
  "UserAdviceAlertView_state_clear": "Effacé",
  "UserAdviceAlertView_state_record": "Enregistré",
  "UserAdviceAlertView_explain_snooze": "Met l'alerte en sourdine quelques minutes. Elle reste ouverte et revient si la situation persiste.",
  "UserAdviceAlertView_explain_acknowledge": "Marque l'alerte comme vue et coupe le son. Elle reste ouverte jusqu'à ce que la situation se résolve.",
  "UserAdviceAlertView_explain_clear": "Ferme l'alerte. À utiliser une fois la situation réellement traitée.",
  "UserAdviceAlertView_explain_record": "Enregistre les feux recommandés dans le journal. Le rappel se ferme de lui-même dès que les feux correspondent.",
  "UserAdviceAlertView_clear_denied": "Seul le skipper ou l'équipage de quart peut effacer cette alerte.",
  "UserAdviceAlertView_clear_confirm_message": "Cela ferme l'alerte pour tout l'équipage, que la situation persiste ou non. À n'effacer qu'une fois qu'elle a réellement été traitée.",
  "UserAdviceAlertView_clear_confirm": "Effacer l'alerte",
  "UserAdviceAlertView_clear_confirm_cancel": "Retour",
  "UserAdviceAlertView_escalate": "Escalader au skipper",
  "UserAdviceAlertView_state_escalate": "Escaladé au skipper",
  "UserAdviceAlertView_explain_escalate": "Alerte le skipper immédiatement au lieu d'attendre l'escalade automatique. Cela annule aussi un acquittement ou un report, afin que l'alarme lui parvienne.",
  "UserAdviceAlertView_skip": "Ignorer",
  "UserAdviceAlertView_acknowledge": "Acquitter",
  "UserAdviceAlertView_clear": "Effacer",
  "UserAdviceAlertView_snooze": "Reporter",
  "UserAdviceAlertView_title": "Alerte {name} - {level}",
  "UserAdviceAlertView_error": "L'action n'a pas pu être effectuée. Veuillez réessayer.",
  "UserAdviceAlertView_read_more": "En savoir plus",

  "UserAdviceAnchorMonitorView": "",
  "UserAdviceAnchorMonitorView_cancel": "Annuler",
  "UserAdviceAnchorMonitorView_disable": "Désactiver",
  "UserAdviceAnchorMonitorView_enable": "Activer l'alarme",
  "UserAdviceAnchorMonitorView_title_inactive": "Alarme de mouillage désactivée",
  "UserAdviceAnchorMonitorView_title_active": "Alarme de mouillage activée",
  "UserAdviceAnchorMonitorView_title_short": "Mouillage",
  "UserAdviceAnchorMonitorView_method": "Méthode",
  "UserAdviceAnchorMonitorView_method_fixedRadius": "Rayon fixe",
  "UserAdviceAnchorMonitorView_method_rodeScope": "Mouillage / touée",
  "UserAdviceAnchorMonitorView_method_sector": "Secteur d'évitage",
  "UserAdviceAnchorMonitorView_warning": "Avertissement",
  "UserAdviceAnchorMonitorView_alarm": "Alarme",
  "UserAdviceAnchorMonitorView_rode": "Mouillage",
  "UserAdviceAnchorMonitorView_depth": "Profondeur",
  "UserAdviceAnchorMonitorView_boatLength": "Longueur du bateau",
  "UserAdviceAnchorMonitorView_bearingFrom": "Du relèvement",
  "UserAdviceAnchorMonitorView_bearingTo": "Au relèvement",
  "UserAdviceAnchorMonitorView_recenter": "Recentrer",
  "UserAdviceAnchorMonitorView_save": "Enregistrer",
  "UserAdviceAnchorMonitorView_snooze": "Reporter",
  "UserAdviceAnchorMonitorView_acknowledge": "Acquitter",
  "UserAdviceAnchorMonitorView_clear": "Effacer",
  "UserAdviceAnchorMonitorView_keepAlive": "Alerter en arrière-plan",
  "UserAdviceAnchorMonitorView_depthWarning": "Avertissement de profondeur",
  "UserAdviceAnchorMonitorView_depthAlarm": "Alarme de profondeur",
  "UserAdviceAnchorMonitorView_error": "L'alarme de mouillage n'a pas pu être mise à jour. Veuillez réessayer.",
  "UserAdviceAnchorMonitorView_error_noPosition": "L'alarme de mouillage a besoin de la position actuelle comme centre, et aucune position n'est disponible pour le moment. Connectez une source GPS NMEA (ou activez le GPS de l'appareil) puis réessayez.",
  "UserAdviceAnchorMonitorView_error_gpsPrecision": "La position actuelle n'est pas assez précise pour l'alarme de mouillage. Elle nécessite une source GPS de haute précision ; le GPS de l'appareil seul est trop imprécis pour mesurer le cercle d'évitage.",
  "UserAdviceAnchorMonitorView_error_noDay": "L'alarme de mouillage ne peut démarrer qu'une fois la journée commencée et une première position enregistrée. Vos réglages ont été enregistrés ; relancez l'alarme de mouillage dès que le journal enregistre.",
  "UserAdviceAnchorMonitorView_read_more": "En savoir plus",

  "UserAdviceEngineMissingView": "",
  "UserAdviceEngineMissingView_title_short": "Moteur ?",
  "UserAdviceEngineMissingView_title_castOff": "Entr\u00e9e moteur manquante ?",
  "UserAdviceEngineMissingView_title_anchorUp": "Entr\u00e9e moteur manquante ?",
  "UserAdviceEngineMissingView_title_motorVessel": "Entr\u00e9e moteur manquante ?",
  "UserAdviceEngineMissingView_text_castOff": "Vous avez appareill\u00e9 sans moteur enregistr\u00e9. Le moteur tournait-il ?",
  "UserAdviceEngineMissingView_text_anchorUp": "Vous avez appareill\u00e9 sans moteur enregistr\u00e9. Le moteur tournait-il ?",
  "UserAdviceEngineMissingView_text_motorVessel": "Le navire fait route sans moteur enregistr\u00e9. Le moteur tournait-il ?",
  "UserAdviceEngineMissingView_all_engines": "Tous les moteurs",
  "UserAdviceEngineMissingView_since_trigger": "Depuis {time}",
  "UserAdviceEngineMissingView_since_now": "\u00c0 partir de maintenant",
  "UserAdviceEngineMissingView_started": "Le moteur tournait",
  "UserAdviceEngineMissingView_sailing": "Non, nous naviguons \u00e0 la voile",
  "UserAdviceEngineMissingView_sailing_noSails": "Aucun moteur en marche",
  "UserAdviceEngineMissingView_cancel": "Annuler",
  "UserAdviceDepthWatchView": "",
  "UserAdviceDepthWatchView_cancel": "Annuler",
  "UserAdviceDepthWatchView_disable": "Désactiver",
  "UserAdviceDepthWatchView_enable": "Activer l'alarme",
  "UserAdviceDepthWatchView_title_inactive": "Alarme de profondeur désactivée",
  "UserAdviceDepthWatchView_title_active": "Alarme de profondeur activée",
  "UserAdviceDepthWatchView_title_short": "Profondeur",
  "UserAdviceDepthWatchView_snooze": "Reporter",
  "UserAdviceDepthWatchView_acknowledge": "Acquitter",
  "UserAdviceDepthWatchView_clear": "Effacer",
  "UserAdviceDepthWatchView_text": "Mettre à jour les seuils d'alerte de profondeur du navire, utilisés par chaque surveillance de profondeur.",
  "UserAdviceDepthWatchView_save": "Enregistrer",
  "UserAdviceDepthWatchView_save_error": "Les réglages de l'alarme de profondeur n'ont pas pu être enregistrés. Veuillez réessayer.",
  "UserAdviceDepthWatchView_error": "L'alarme de profondeur n'a pas pu être mise à jour. Veuillez réessayer.",

  "UserAdviceLightsReminderView": "",
  "UserAdviceLightsReminderView_title": "Signaux visuels",
  "UserAdviceLightsReminderView_title_active": "Rappel des signaux visuels activé",
  "UserAdviceLightsReminderView_title_inactive": "Rappel des signaux visuels désactivé",

  "UserAdviceManualShipStatusView": "",
  "UserAdviceManualShipStatusView_title_active": "Statut manuel jusqu'à {time}",
  "UserAdviceManualShipStatusView_title_short": "Statut manuel",
  "UserAdviceManualShipStatusView_text": "Les changements de statut automatiques sont désactivés. Définissez vous-même le statut du navire dans le menu du journal — tant que ce mode est actif, aucune entrée n'est créée automatiquement.",
  "UserAdviceManualShipStatusView_remaining": "Se termine à {time}, dans environ {minutes} minutes — ou au changement de jour, selon ce qui arrive en premier.",
  "UserAdviceManualShipStatusView_extend": "Prolonger",
  "UserAdviceManualShipStatusView_cancel": "Terminer maintenant",
  "UserAdviceManualShipStatusView_close": "Fermer",
  "UserAdviceManualShipStatusView_error": "Le mode statut manuel n'a pas pu être mis à jour. Veuillez réessayer.",

  "UserAdviceStopView": "",
  "UserAdviceStopView_cancel": "Annuler",
  "UserAdviceStopView_text": "Documentez l'arrêt. Fin de journée suspend l'enregistrement automatique jusqu'à ce que le navire reparte ; Escale le maintient actif.",
  "UserAdviceStopView_text_fixed_status": "Ajoutez Fin de journée ou Escale sans modifier le statut actuel du navire. Fin de journée suspend l'enregistrement automatique jusqu'à ce que le navire reparte ; Escale le maintient actif.",
  "UserAdviceStopView_end_location": "Emplacement",
  "UserAdviceStopView_end_of_day": "Fin de journée",
  "UserAdviceStopView_manual_engine_entries": "Également arrêté le(s) moteur(s) ?",
  "UserAdviceStopView_manual_engine_entries_text": "L'activation de cette option créera également une entrée finale pour le fonctionnement du moteur",
  "UserAdviceStopView_final_entry": "Créer une entrée finale",
  "UserAdviceStopView_save": "Enregistrer",
  "UserAdviceStopView_status_anchor": "Mouillage",
  "UserAdviceStopView_status_buoy": "Bouée",
  "UserAdviceStopView_status_port": "Port",
  "UserAdviceStopView_status_drifting": "À la dérive",
  "UserAdviceStopView_stopover": "Escale",
  "UserAdviceStopView_status_lock": "Écluse",
  "UserAdviceStopView_status_bunkering": "Station de carburant",
  "UserAdviceStopView_status_bridge": "Pont",
  "UserAdviceStopView_status_waiting": "Attente",
  "UserAdviceStopView_stop_engines": "Créer une entrée pour le(s) moteur(s) arrêté(s)",
  "UserAdviceStopView_stop_type": "Type d'arrêt",
  "UserAdviceStopView_title": "Arrêté",
  "UserAdviceStopView_title_duration": "Arrêté pendant {duration}",
  "UserAdviceStopView_title_short": "Arrêté",
  "UserAdviceRow_collapse": "Afficher moins",
  "UserAdviceRow_expand": "Afficher tous les avis",

  "UserSettingsView": "",
  "UserSettingsView_lang_en": "English",
  "UserSettingsView_lang_de": "Deutsch",
  "UserSettingsView_lang_fr": "Français",
  "UserSettingsView_theme_dark": "Sombre",
  "UserSettingsView_theme_light": "Classique",
  "UserSettingsView_theme_night": "Nuit",
  "UserSettingsView_theme_cloud": "Cloud",
  "UserSettingsView_language": "Langue",
  "UserSettingsView_theme": "Thème",

  "UserSwitchView": "",
  "UserSwitchView_title": "Changer d'utilisateur",
  "UserSwitchView_empty": "Aucun autre membre d'équipage n'est enregistré pour aujourd'hui.",

  "Mailer_trial_started_subject": "Votre période d'essai LOGBOOK a commencé",
  "Mailer_trial_2daysleft_subject": "Votre période d'essai LOGBOOK se termine bientôt",
  "Mailer_trial_expired_subject": "Votre période d'essai LOGBOOK a expiré",
  "Mailer_subscription_expired_subject": "Votre abonnement LOGBOOK a expiré",

  "LogButton": "",
  "LogButton_status": "Statut",
  "LogButton_engines": "Moteurs",
  "LogButton_generators": "Générateurs",
  "LogButton_lighting": "Feux",
  "LogButton_lighting_none": "Aucun feu",
  "LogButton_lighting_triColorLights": "Feu tricolore",
  "LogButton_lighting_anchorBall": "Boule de mouillage",
  "LogButton_lighting_anchorLight": "Feu de mouillage",
  "LogButton_lighting_sailingRunningLights": "Feux de navigation à la voile",
  "LogButton_lighting_motoringRunningLights": "Feux de navigation au moteur",
  "LogButton_lighting_navigationLights": "Feux de navigation",
  "LogButton_lighting_motoringCone": "Cône de moteur",
  "LogButton_sails": "Voiles",
  "LogButton_sails_confirm": "Enregistrer les voiles",
  "LogButton_sail_group_main": "Grand-voile",
  "LogButton_sail_group_foresail": "Voile d'avant",
  "LogButton_sail_group_spinnaker": "Spinnaker",
  "LogButton_sail_group_mizzen": "Artimon",
  "LogButton_send_alert": "Envoyer une alerte",
  "LogButton_man_overboard": "Homme à la mer",
  "LogButton_man_overboard_confirm_title": "Homme à la mer",
  "LogButton_man_overboard_confirm_message": "Ceci alertera immédiatement tout l'équipage qu'une personne est passée par-dessus bord. Ne confirmez que si c'est réel.",
  "LogButton_man_overboard_confirm": "Déclencher l'alerte",
  "LogButton_man_overboard_cancel": "Annuler",
  "LogButton_man_overboard_error": "Impossible de déclencher l'alerte homme à la mer.",
  "LogButton_manual_status": "Statut manuel",
  "LogButton_manual_status_active": "Statut manuel activé — désactiver",
  "SendAlertDialog": "",
  "SendAlertDialog_title": "Envoyer une alerte",
  "SendAlertDialog_users": "Membres d'\u00E9quipage",
  "SendAlertDialog_add_user": "Ajouter un membre d'\u00E9quipage",
  "SendAlertDialog_groups": "Groupes de quart",
  "SendAlertDialog_add_group": "Ajouter un groupe de quart",
  "SendAlertDialog_message": "Message",
  "SendAlertDialog_severity": "Gravit\u00E9",
  "SendAlertDialog_severity_warning": "Avertissement",
  "SendAlertDialog_severity_alarm": "Alarme",
  "SendAlertDialog_loudness": "Volume",
  "SendAlertDialog_loudness_audible": "Alarme sonore",
  "SendAlertDialog_loudness_notificationOnly": "Notification seule",
  "SendAlertDialog_error": "L'alerte n'a pas pu \u00EAtre envoy\u00E9e. Veuillez r\u00E9essayer.",
  "SendAlertDialog_cancel": "Annuler",
  "SendAlertDialog_send": "Envoyer",
  "CatalogUserAdviceButton": "",
  "CatalogUserAdviceButton_notice": "Veille d'ancre active",
  "CatalogUserAdviceButton_warning": "Le vent se l\u00E8ve",
  "CatalogUserAdviceButton_alarm": "Homme \u00E0 la mer !",
  "CatalogUserAdviceButton_short": "MOB",
  "CatalogUserAdviceButton_record": "Enregistrer le feu de mouillage",
  "CatalogUserAdviceButton_primary-action": "Signaux visuels",
  "CatalogUserAdviceButton_primary-action-denied": "Signaux visuels",
  "CatalogUserAdviceRow": "",
  "CatalogUserAdviceRow_manOverboard": "Homme à la mer",
  "CatalogUserAdviceRow_manOverboard_short": "MOB",
  "CatalogUserAdviceRow_anchorDrift": "Dérive du mouillage",
  "CatalogUserAdviceRow_anchorDrift_short": "Dérive",
  "CatalogUserAdviceRow_depth": "Alarme de profondeur activée",
  "CatalogUserAdviceRow_depth_short": "Profondeur",
  "CatalogUserAdviceRow_lostPosition": "Position perdue",
  "CatalogUserAdviceRow_lostPosition_short": "Position",
  "CatalogUserAdviceRow_wind": "Alerte de vent",
  "CatalogUserAdviceRow_wind_short": "Vent",
  "CatalogUserAdviceRow_stop": "Arrêté pendant 0:12:04",
  "CatalogUserAdviceRow_stop_short": "Arrêté",
  "": ""
}
